export default function ApiCommon() {

	return(
<div className="nk-content">
  <div className="container-fluid">
    <div className="nk-content-inner">
      <div className="nk-content-body">
        <div className="nk-block vApiAbout">
          <div className="card card-bordered m-3 mb-4">
            <div className="card-inner-group">
              <div className="card-inner p-3">
                <div className="card">
                  <div className="row p-0 pointer">
                    <div className="col text-primary h5 m-0">소개</div>
                  </div>
                  <div
                    className="col-sm-12 col-md-12 bg-primary mt-2"
                    style={{
                      height: "1px",
                    }}
                  />
                  <div className="row">
                    <div className="col-sm-12 col-md-12 p-4">
                      지갑유형에 상관없이 당사 API를 이용하려면 공통으로
                      제공되는 게임/게임사 정보, 회원가입, 게임 실행 방법 등의
                      API연동이 선행되어야 합니다
                      <br />
                      <br /> 게임/게임사 정보: 신규 게임, 게임사 정보
                      <br />
                      회원가입: 신규 회원정보 & 회원 인증
                      <br /> 게임실행: 게임실행을 위한 게임URL 제공
                      <br /> 아래에 명시된 API를 연동한 이후, 귀사에 적합한 API
                      연동 방식을 선택하여 진행하시기 바랍니다
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="card card-bordered m-3 mb-4">
            <div className="card-inner-group">
              <div className="card-inner p-3">
                <div className="card">
                  <div className="row p-0 pointer">
                    <div className="col text-primary h5 m-0">
                      {" "}
                      1. 게임사 목록 조회{" "}
                      <span className="badge badge-dim bg-outline-info me-1">
                        선택
                      </span>
                      <span className="badge badge-dim bg-outline-warning me-1">
                        권장
                      </span>
                    </div>
                    <div className="col-auto text-end">
                      <i className="fas fa-chevron-circle-up col text-primary" />
                    </div>
                  </div>
                  <div
                    className="col-sm-12 col-md-12 bg-primary mt-2"
                    style={{
                      height: "1px",
                    }}
                  />
                  <div className="row">
                    <div className="col-sm-12 col-md-12 p-4">
                      <div className="nk-block vApiVendors">
                        <div className="card">
                          <div className="row">
                            <div className="col-sm-12 col-md-12">
                              <div className="p-1" id="menu1">
                                <div className="card text-bg-light">
                                  <div className="card-header">
                                    <h5>Info</h5>
                                  </div>
                                  <div className="card-body">
                                    <dd>
                                      귀사가 사용할 수 있는 게임사 목록을
                                      조회합니다
                                    </dd>
                                    <dd>
                                      이 목록은 [당사 관리 페이지 → 관리 →
                                      벤더관리/한도제한] 페이지의 활성/비활성
                                      설정에 따라 다를 수 있습니다
                                    </dd>
                                    <dd>
                                      특정 게임사가 표시되지 않는다면 먼저
                                      해당메뉴에서 비활성여부를 확인해주세요
                                    </dd>
                                    <br />
                                    <dd>
                                      게임사 정보는 귀사가 사용중인 화폐(KRW)를 기준으로 제공되는 정보의 차이가 있을
                                      수 있습니다
                                    </dd>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-xl-8 col-xxl-8">
                                  <div className="p-1" id="menu2">
                                    <div className="card text-bg-light">
                                      <div className="card-header">
                                        <h5>API Data</h5>
                                      </div>
                                      <div className="card-body">
                                        <h6 className="mt-1 card-subtitle mb-2 text-body-secondary">
                                          <span className="text-primary">
                                            Request Url
                                          </span>
                                        </h6>
                                        <input
                                          className="form-control"
                                          disabled
                                          type="text"
                                          value={"https://mtxgamehub.com/api/getgame.php"}
                                        />
                                        <hr />
                                        <h6 className="mt-1 card-subtitle mb-2 text-body-secondary">
                                          <span className="text-primary">
                                            Header Data
                                          </span>
                                        </h6>
                                        <div className="table-responsive">
                                          <table className="table table-primary mb-2">
                                            <colgroup>
                                              <col />
                                              <col />
                                              <col />
                                              <col />
                                              <col />
                                            </colgroup>
                                            <thead>
                                              <tr>
                                                <th className="text-center">
                                                  <b>Field</b>
                                                </th>
                                                <th className="text-center">
                                                  <b>Value</b>
                                                </th>
                                                <th className="text-center">
                                                  <b>Required</b>
                                                </th>
                                                <th className="text-center">
                                                  <b>Desc</b>
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr>
                                                <td>
                                                  <b>method</b>
                                                </td>
                                                <td>
                                                  <div className="form-group">
                                                    <input
                                                      className="form-control"
                                                      disabled
                                                      type="text"
                                                      value ={"POST"}
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center">
                                                  <span className="badge bg-info">
                                                    YES
                                                  </span>
                                                </td>
                                                <td>POST</td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <b>accept</b>
                                                </td>
                                                <td>
                                                  <div className="form-group">
                                                    <input
                                                      className="form-control"
                                                      disabled
                                                      type="text"
                                                       value ={"application/json"}
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center">
                                                  <span className="badge bg-info">
                                                    YES
                                                  </span>
                                                </td>
                                                <td>Application type</td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <b>content-type</b>
                                                </td>
                                                <td>
                                                  <div className="form-group">
                                                    <input
                                                      className="form-control"
                                                      disabled
                                                      type="text"
                                                      value ={"application/x-www-form-urlencoded"}
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center">
                                                  <span className="badge bg-info">
                                                    YES
                                                  </span>
                                                </td>
                                                <td>Application</td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                        <div className="form-group text-center">
                                          <button
                                            className="btn btn-primary btn-lg"
                                            type="submit">
                                            <i className="fas fa-paper-plane" />
                                            Request{" "}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-xl-4 col-xxl-4">
                                  <div className="p-1" id="menu3">
                                    <div className="card text-bg-light">
                                      <div className="card-header">
                                        <h5>CODE</h5>
                                      </div>
                                      <div className="card-body">
                                        <ul
                                          className="nav nav-tabs nav-pills mb-3"
                                          id="animateLine"
                                          role="tablist">
                                          <li className="nav-item">
                                            <button
                                              className="nav-link active"
                                              data-bs-target="#tab-menu5-vendors"
                                              data-bs-toggle="tab"
                                              id="home-tab"
                                              type="button">
                                              {" "}
                                              Res Data{" "}
                                            </button>
                                          </li>
                                          <li className="nav-item">
                                            <button
                                              className="nav-link"
                                              data-bs-target="#tab-menu1-vendors"
                                              data-bs-toggle="tab"
                                              id="home-tab"
                                              type="button">
                                              {" "}
                                              NodeJs{" "}
                                            </button>
                                          </li>
                                          <li className="nav-item">
                                            <button
                                              className="nav-link"
                                              data-bs-target="#tab-menu2-vendors"
                                              data-bs-toggle="tab">
                                              {" "}
                                              PHP
                                            </button>
                                          </li>
                                          <li className="nav-item">
                                            <button
                                              className="nav-link"
                                              data-bs-target="#tab-menu3-vendors"
                                              data-bs-toggle="tab">
                                              {" "}
                                              Java
                                            </button>
                                          </li>
                                          <li className="nav-item">
                                            <button
                                              className="nav-link"
                                              data-bs-target="#tab-menu4-vendors"
                                              data-bs-toggle="tab">
                                              {" "}
                                              Asp
                                            </button>
                                          </li>
                                        </ul>
                                        <div
                                          className="tab-content"
                                          id="iconTabContent-1">
                                          <div
                                            className="tab-pane fade show active"
                                            id="tab-menu5-vendors">
                                            <pre className="rounded-lg">
                                              <code className="javascript hljs">
                                                {`{  `}
                                                <span className="hljs-string">
                                                  "code"
                                                </span>
                                                :{" "}
                                                <span className="hljs-number">
                                                  0
                                                </span>
                                                ,
                                                <span className="hljs-comment">
                                                  // 0: 정상, -1: 오류 메시지
                                                  확인
                                                </span>
                                                <span className="hljs-string">
                                                  "vendors"
                                                </span>
                                                {`: [	{	  `}
                                                <span className="hljs-string">
                                                  "row_num"
                                                </span>{" "}
                                                :{" "}
                                                <span className="hljs-number">
                                                  1
                                                </span>
                                                ,
                                                <span className="hljs-comment">
                                                  // Record number(정렬순)
                                                </span>
                                                <span className="hljs-string">
                                                  "key"
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  "evolution-n"
                                                </span>
                                                ,
                                                <span className="hljs-comment">
                                                  // 벤더키
                                                </span>
                                                <span className="hljs-string">
                                                  "name"
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  "에볼루션 카지노"
                                                </span>
                                                ,
                                                <span className="hljs-comment">
                                                  // 벤더명
                                                </span>
                                                <span className="hljs-string">
                                                  "category"
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  "casino"
                                                </span>
                                                <span className="hljs-comment">
                                                  // 카테고리
                                                </span>
                                                <span className="hljs-string">
                                                  "skins"
                                                </span>
                                                {`: [		{		  `}
                                                <span className="hljs-string">
                                                  "skin"
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  "A"
                                                </span>
                                                ,
                                                <span className="hljs-comment">
                                                  // 스킨
                                                </span>
                                                <span className="hljs-string">
                                                  "name"
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  "1,000 ~ 1,000,000"
                                                </span>{" "}
                                                <span className="hljs-comment">
                                                  // 스킨 한도
                                                </span>
                                                {`		}		...	  ]	}	...  ]}																										`}
                                              </code>
                                            </pre>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="tab-menu1-vendors">
                                            <pre className="rounded-lg">
                                              <code className="javascript hljs">
                                                <span className="hljs-keyword">
                                                  var
                                                </span>{" "}
                                                axios ={" "}
                                                <span className="hljs-built_in">
                                                  require
                                                </span>
                                                (
                                                <span className="hljs-string">
                                                  'axios'
                                                </span>
                                                );
                                                <span className="hljs-keyword">
                                                  var
                                                </span>{" "}
                                                qs ={" "}
                                                <span className="hljs-built_in">
                                                  require
                                                </span>
                                                (
                                                <span className="hljs-string">
                                                  'qs'
                                                </span>
                                                );
                                                <span className="hljs-keyword">
                                                  var
                                                </span>
                                                {` data = qs.stringify({});`}
                                                <span className="hljs-keyword">
                                                  var
                                                </span>
                                                {` config = {  `}
                                                <span className="hljs-attr">
                                                  method
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  'post'
                                                </span>
                                                ,
                                                <span className="hljs-attr">
                                                  url
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  'API 요청 URL/vendors'
                                                </span>
                                                ,
                                                <span className="hljs-attr">
                                                  headers
                                                </span>
                                                {`: {	`}
                                                <span className="hljs-string">
                                                  'agent'
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  'Matrixgames'
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  'secretKey'
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  'ce3da8a33f5f6dae8620f3126ac6cd0b'
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  'User-agent'
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  'Mozilla'
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  'hash'
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  'null'
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  'Content-Type'
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  'application/x-www-form-urlencoded'
                                                </span>
                                                {`  },  `}
                                                <span className="hljs-attr">
                                                  data
                                                </span>
                                                {` : data};axios(config).then(`}
                                                <span className="hljs-function">
                                                  <span className="hljs-keyword">
                                                    function
                                                  </span>{" "}
                                                  (
                                                  <span className="hljs-params">
                                                    response
                                                  </span>
                                                  ){" "}
                                                </span>
                                                {`{  `}
                                                <span className="hljs-built_in">
                                                  console
                                                </span>
                                                .log(
                                                <span className="hljs-built_in">
                                                  JSON
                                                </span>
                                                {`.stringify(response.data));}).catch(`}
                                                <span className="hljs-function">
                                                  <span className="hljs-keyword">
                                                    function
                                                  </span>{" "}
                                                  (
                                                  <span className="hljs-params">
                                                    error
                                                  </span>
                                                  ){" "}
                                                </span>
                                                {`{  `}
                                                <span className="hljs-built_in">
                                                  console
                                                </span>
                                                {`.log(error);});																										`}
                                              </code>
                                            </pre>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="tab-menu2-vendors">
                                            <pre className="rounded-lg">
                                              <code className="php hljs">
                                                <span className="hljs-meta">
                                                  {`<?php`}
                                                </span>
                                                <span className="hljs-variable">
                                                  $curl
                                                </span>{" "}
                                                = curl_init();curl_setopt_array(
                                                <span className="hljs-variable">
                                                  $curl
                                                </span>
                                                ,{" "}
                                                <span className="hljs-keyword">
                                                  array
                                                </span>
                                                {`(  CURLOPT_URL => `}
                                                <span className="hljs-string">
                                                  'API 요청 URL/vendors'
                                                </span>
                                                {`,  CURLOPT_RETURNTRANSFER => `}
                                                <span className="hljs-literal">
                                                  true
                                                </span>
                                                {`,  CURLOPT_ENCODING => `}
                                                <span className="hljs-string">
                                                  ''
                                                </span>
                                                {`,  CURLOPT_MAXREDIRS => `}
                                                <span className="hljs-number">
                                                  10
                                                </span>
                                                {`,  CURLOPT_TIMEOUT => `}
                                                <span className="hljs-number">
                                                  0
                                                </span>
                                                {`,  CURLOPT_FOLLOWLOCATION => `}
                                                <span className="hljs-literal">
                                                  true
                                                </span>
                                                {`,  CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,  CURLOPT_CUSTOMREQUEST => `}
                                                <span className="hljs-string">
                                                  'POST'
                                                </span>
                                                {`,  CURLOPT_POSTFIELDS => `}
                                                <span className="hljs-string">
                                                  ''
                                                </span>
                                                {`,  CURLOPT_HTTPHEADER => `}
                                                <span className="hljs-keyword">
                                                  array
                                                </span>
                                                (
                                                <span className="hljs-string">
                                                  'agent: Matrixgames'
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  'secretKey:
                                                  ce3da8a33f5f6dae8620f3126ac6cd0b'
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  'User-agent: Mozilla'
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  'hash: null'
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  'Content-Type:
                                                  application/x-www-form-urlencoded'
                                                </span>
                                                ),));
                                                <span className="hljs-variable">
                                                  $response
                                                </span>{" "}
                                                = curl_exec(
                                                <span className="hljs-variable">
                                                  $curl
                                                </span>
                                                );curl_close(
                                                <span className="hljs-variable">
                                                  $curl
                                                </span>
                                                );
                                                <span className="hljs-keyword">
                                                  echo
                                                </span>{" "}
                                                <span className="hljs-variable">
                                                  $response
                                                </span>
                                                ;
                                              </code>
                                            </pre>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="tab-menu3-vendors">
                                            <pre className="rounded-lg">
                                              <code className="java hljs">
                                                OkHttpClient client ={" "}
                                                <span className="hljs-keyword">
                                                  new
                                                </span>{" "}
                                                OkHttpClient().newBuilder().build();MediaType
                                                mediaType = MediaType.parse(
                                                <span className="hljs-string">
                                                  "application/x-www-form-urlencoded"
                                                </span>
                                                );RequestBody body =
                                                RequestBody.create(mediaType,{" "}
                                                <span className="hljs-string">
                                                  ""
                                                </span>
                                                );Request request ={" "}
                                                <span className="hljs-keyword">
                                                  new
                                                </span>{" "}
                                                Request.Builder() .url(
                                                <span className="hljs-string">
                                                  "API 요청 URL/vendors"
                                                </span>
                                                ) .method(
                                                <span className="hljs-string">
                                                  "POST"
                                                </span>
                                                , body) .addHeader(
                                                <span className="hljs-string">
                                                  "agent"
                                                </span>
                                                ,{" "}
                                                <span className="hljs-string">
                                                  "Matrixgames"
                                                </span>
                                                ) .addHeader(
                                                <span className="hljs-string">
                                                  "secretKey"
                                                </span>
                                                ,{" "}
                                                <span className="hljs-string">
                                                  "ce3da8a33f5f6dae8620f3126ac6cd0b"
                                                </span>
                                                ) .addHeader(
                                                <span className="hljs-string">
                                                  "User-agent"
                                                </span>
                                                ,{" "}
                                                <span className="hljs-string">
                                                  "Mozilla"
                                                </span>
                                                ) .addHeader(
                                                <span className="hljs-string">
                                                  "hash"
                                                </span>
                                                ,{" "}
                                                <span className="hljs-string">
                                                  "null"
                                                </span>
                                                ) .addHeader(
                                                <span className="hljs-string">
                                                  "Content-Type"
                                                </span>
                                                ,{" "}
                                                <span className="hljs-string">
                                                  "application/x-www-form-urlencoded"
                                                </span>
                                                ) .build();Response response =
                                                client.newCall(request).execute();
                                              </code>
                                            </pre>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="tab-menu4-vendors">
                                            <pre className="rounded-lg">
                                              <code className="asp hljs gams">
                                                {`<%`}
                                                <span className="hljs-keyword">
                                                  set
                                                </span>{" "}
                                                req{" "}
                                                <span className="hljs-comment">
                                                  = Server.CreateObject(
                                                </span>
                                                <span className="hljs-comment">
                                                  "MSXML2.ServerXMLHTTP"
                                                </span>
                                                <span className="hljs-comment">
                                                  )
                                                </span>
                                                req.open{" "}
                                                <span className="hljs-comment">
                                                  "POST"
                                                </span>
                                                <span className="hljs-comment">
                                                  ,
                                                </span>{" "}
                                                <span className="hljs-comment">
                                                  "API 요청 URL/vendors"
                                                </span>
                                                <span className="hljs-comment">
                                                  , False
                                                </span>
                                                req.setRequestHeader{" "}
                                                <span className="hljs-comment">
                                                  "accept"
                                                </span>
                                                <span className="hljs-comment">
                                                  ,
                                                </span>{" "}
                                                <span className="hljs-comment">
                                                  "application/json"
                                                </span>
                                                req.setRequestHeader{" "}
                                                <span className="hljs-comment">
                                                  "Content-Type"
                                                </span>
                                                <span className="hljs-comment">
                                                  ,
                                                </span>{" "}
                                                <span className="hljs-comment">
                                                  "application/x-www-form-urlencoded"
                                                </span>
                                                req.setRequestHeader{" "}
                                                <span className="hljs-comment">
                                                  "agent"
                                                </span>
                                                <span className="hljs-comment">
                                                  ,
                                                </span>
                                                <span className="hljs-comment">
                                                  "Matrixgames"
                                                </span>{" "}
                                                req.setRequestHeader{" "}
                                                <span className="hljs-comment">
                                                  "secretKey"
                                                </span>
                                                <span className="hljs-comment">
                                                  ,
                                                </span>{" "}
                                                <span className="hljs-comment">
                                                  "ce3da8a33f5f6dae8620f3126ac6cd0b"
                                                </span>{" "}
                                                req.setRequestHeader{" "}
                                                <span className="hljs-comment">
                                                  "hash"
                                                </span>
                                                <span className="hljs-comment">
                                                  ,
                                                </span>{" "}
                                                <span className="hljs-comment">
                                                  "null"
                                                </span>{" "}
                                                req.send{" "}
                                                <span className="hljs-comment">
                                                  ""
                                                </span>
                                                data{" "}
                                                <span className="hljs-comment">
                                                  = req.responseText
                                                </span>
                                                {`%>																										`}
                                              </code>
                                            </pre>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="p-1" id="menu4">
                                <div className="card text-bg-light">
                                  <div className="card-header">
                                    <h5>RESPONSE</h5>
                                  </div>
                                  <div className="card-body">
                                    <h6 className="mt-1 card-subtitle mb-2 text-body-secondary">
                                      <span className="text-primary">
                                        Response info
                                      </span>
                                    </h6>
                                    <div className="table-responsive">
                                      <table className="table mb-2">
                                        <colgroup>
                                          <col />
                                          <col />
                                          <col />
                                        </colgroup>
                                        <thead>
                                          <tr>
                                            <th className="text-center">
                                              Field
                                            </th>
                                            <th className="text-center">
                                              Type
                                            </th>
                                            <th className="text-center">
                                              Value
                                            </th>
                                            <th className="text-center">
                                              Desc
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <b>code</b>
                                            </td>
                                            <td>Number</td>
                                            <td>0</td>
                                            <td>
                                              0: 정상, -1: 오류 메시지 확인
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <b>msg</b>
                                            </td>
                                            <td>String</td>
                                            <td>오류 메시지</td>
                                            <td>오류 메시지</td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <b>vendors</b>
                                            </td>
                                            <td>Array</td>
                                            <td>
                                              {" "}
                                              row_num: Record number(정렬순)
                                              <br /> key : 벤더키
                                              <br /> name : 벤더명
                                              <br /> category : 카테고리
                                              <br /> skins.skin : 스킨
                                              <br /> skins.name : 스킨 한도
                                              <br />
                                            </td>
                                            <td>게임사 목록</td>
                                          </tr>
                                        </tbody>
                                      </table>
                                      <h6 className="mt-1 card-subtitle mb-2 text-body-secondary">
                                        <span className="text-primary">
                                          Response Data
                                        </span>
                                      </h6>
                                      <div className="form-group">
                                        <pre className="rounded-lg">
                                          <code className="returnData json hljs" />
                                        </pre>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card card-bordered m-3 mb-4">
            <div className="card-inner-group">
              <div className="card-inner p-3">
                <div className="card">
                  <div className="row p-0 pointer">
                    <div className="col text-primary h5 m-0">
                      {" "}
                      2. 게임 목록 조회{" "}
                      <span className="badge badge-dim bg-outline-danger me-1">
                        필수
                      </span>
                    </div>
                    <div className="col-auto text-end">
                      <i className="fas fa-chevron-circle-up col text-primary" />
                    </div>
                  </div>
                  <div
                    className="col-sm-12 col-md-12 bg-primary mt-2"
                    style={{
                      height: "1px",
                    }}
                  />
                  <div className="row">
                    <div className="col-sm-12 col-md-12 p-4">
                      <div className="nk-block vApiGames">
                        <div className="card">
                          <div className="row">
                            <div className="col-sm-12 col-md-12">
                              <div className="p-1" id="menu1">
                                <div className="card text-bg-light">
                                  <div className="card-header">
                                    <h5>Info</h5>
                                  </div>
                                  <div className="card-body">
                                    <dd>
                                      {`귀사가 사용할 수 있는 게임 목록을 조회합니다. 이 목록은 [당사 관리 페이지 > 관리 > 게임관리] 설정에 따라 다를 수 있습니다`}
                                    </dd>
                                    <dd>
                                      게임정보는 게임(벤더)사 정보를 기준으로
                                      제공됩니다
                                    </dd>
                                    <br /> 귀사가 사용할 수 있는 게임사 목록을
                                    조회합니다
                                    <br /> 이 목록은 [당사 관리 페이지 → 관리 →
                                    게임관리/한도제한] 페이지의 활성/비활성
                                    설정에 따라 다를 수 있습니다
                                    <br />
                                    <br /> 슬롯의 경우 아래와 같이 게임타입이
                                    나누어져 있으며, 필요한 타입을 선택하여
                                    조회할수 있습니다
                                    <br /> 게임타입 :{" "}
                                    <span className="text-azure">
                                      Slot, Arcade, Fishing, Bingo, Table Games
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-xl-8 col-xxl-8">
                                  <div className="p-1" id="menu2">
                                    <div className="card text-bg-light">
                                      <div className="card-header">
                                        <h5>API Data</h5>
                                      </div>
                                      <div className="card-body">
                                        <h6 className="mt-1 card-subtitle mb-2 text-body-secondary">
                                          <span className="text-primary">
                                            Request Url
                                          </span>
                                        </h6>
                                        <input
                                          className="form-control"
                                          disabled
                                          type="text"
                                        />
                                        <hr />
                                        <h6 className="mt-1 card-subtitle mb-2 text-body-secondary">
                                          <span className="text-primary">
                                            Header Data
                                          </span>
                                        </h6>
                                        <div className="table-responsive">
                                          <table className="table table-primary mb-2">
                                            <colgroup>
                                              <col />
                                              <col />
                                              <col />
                                              <col />
                                              <col />
                                            </colgroup>
                                            <thead>
                                              <tr>
                                                <th className="text-center">
                                                  <b>Field</b>
                                                </th>
                                                <th className="text-center">
                                                  <b>Value</b>
                                                </th>
                                                <th className="text-center">
                                                  <b>Required</b>
                                                </th>
                                                <th className="text-center">
                                                  <b>Desc</b>
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr>
                                                <td>
                                                  <b>method</b>
                                                </td>
                                                <td>
                                                  <div className="form-group">
                                                    <input
                                                      className="form-control"
                                                      disabled
                                                      type="text"
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center">
                                                  <span className="badge bg-info">
                                                    YES
                                                  </span>
                                                </td>
                                                <td>POST</td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <b>accept</b>
                                                </td>
                                                <td>
                                                  <div className="form-group">
                                                    <input
                                                      className="form-control"
                                                      disabled
                                                      type="text"
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center">
                                                  <span className="badge bg-info">
                                                    YES
                                                  </span>
                                                </td>
                                                <td>Application type</td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <b>content-type</b>
                                                </td>
                                                <td>
                                                  <div className="form-group">
                                                    <input
                                                      className="form-control"
                                                      disabled
                                                      type="text"
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center">
                                                  <span className="badge bg-info">
                                                    YES
                                                  </span>
                                                </td>
                                                <td>Application</td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <b>hash</b>
                                                </td>
                                                <td>
                                                  <div className="form-group">
                                                    <input
                                                      className="form-control"
                                                      disabled
                                                      type="text"
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center">
                                                  <span className="badge bg-info">
                                                    YES
                                                  </span>
                                                </td>
                                                <td>hash</td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <b>agent</b>
                                                </td>
                                                <td>
                                                  <div className="form-group">
                                                    <input
                                                      className="form-control"
                                                      disabled
                                                      type="text"
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center">
                                                  <span className="badge bg-info">
                                                    YES
                                                  </span>
                                                </td>
                                                <td>에이전트 아이디</td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                        <h6 className="mt-1 card-subtitle mb-2 text-body-secondary">
                                          <span className="text-primary">
                                            Body Data
                                          </span>
                                        </h6>
                                        <div className="table-responsive">
                                          <table className="table mb-2">
                                            <colgroup>
                                              <col />
                                              <col />
                                              <col />
                                              <col />
                                              <col />
                                            </colgroup>
                                            <thead>
                                              <tr>
                                                <th className="text-center">
                                                  <b>Field</b>
                                                </th>
                                                <th className="text-center">
                                                  <b>Value</b>
                                                </th>
                                                <th className="text-center">
                                                  <b>Select</b>
                                                </th>
                                                <th className="text-center">
                                                  <b>Type</b>
                                                </th>
                                                <th className="text-center">
                                                  <b>Required</b>
                                                </th>
                                                <th className="text-center">
                                                  <b>Desc</b>
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr>
                                                <td className="align-middle">
                                                  <b>vendorKey</b>
                                                </td>
                                                <td className="align-middle">
                                                  <div className="form-group align-middle">
                                                    <input
                                                      className="form-control"
                                                      type="text"
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center align-middle">
                                                  <div className="form-wrap align-middle">
                                                    <select
                                                      className="form-select js-select2"
                                                      data-placeholder="에볼루션 카지노"
                                                      data-search="off"
                                                      id="selectVendor_game">
                                                      <option value="evolution_casino">
                                                        에볼루션 카지노
                                                      </option>
                                                      <option value="dreamgaming_casino">
                                                        드림게이밍
                                                      </option>
                                                      <option value="ag_casino">
                                                        아시안게이밍 카지노
                                                      </option>
                                                      <option value="pragmatic_casino">
                                                        프라그마틱 카지노
                                                      </option>
                                                      <option value="mggrand_casino">
                                                        마이크로게이밍 그랜드
                                                        카지노
                                                      </option>
                                                      <option value="mggrand_slot">
                                                        word.마이크로게이밍
                                                        그랜드 슬롯
                                                      </option>
                                                      <option value="orientalgame_casino">
                                                        오리엔탈 게이밍
                                                      </option>
                                                      <option value="bg_casino">
                                                        빅게이밍
                                                      </option>
                                                      <option value="motivation_casino">
                                                        모티베이션 카지노
                                                      </option>
                                                      <option value="ezugi_casino">
                                                        이주기
                                                      </option>
                                                      <option value="taishan_casino">
                                                        타이산 카지노
                                                      </option>
                                                      <option value="skywind_casino">
                                                        스카이윈드 카지노
                                                      </option>
                                                      <option value="betgames_casino">
                                                        벳게임즈 TV
                                                      </option>
                                                      <option value="sexy_casino">
                                                        섹시 바카라
                                                      </option>
                                                      <option value="dblive_casino">
                                                        DB Live 카지노
                                                      </option>
                                                      <option value="bota_casino">
                                                        보타 카지노
                                                      </option>
                                                      <option value="pragmatic_slot">
                                                        프라그마틱 슬롯
                                                      </option>
                                                      <option value="ag_slot">
                                                        아시안게이밍 슬롯
                                                      </option>
                                                      <option value="habanero_slot">
                                                        하바네로
                                                      </option>
                                                      <option value="blueprint_slot">
                                                        블루프린트 슬롯
                                                      </option>
                                                      <option value="cq9_slot">
                                                        CQ9 슬롯
                                                      </option>
                                                      <option value="evolution_redtiger">
                                                        레드타이거
                                                      </option>
                                                      <option value="spearhead_slot">
                                                        슬롯 매트릭스
                                                      </option>
                                                      <option value="gmw_slot">
                                                        GMW
                                                      </option>
                                                      <option value="booongo_slot">
                                                        부운고
                                                      </option>
                                                      <option value="netent_slot">
                                                        넷엔트
                                                      </option>
                                                      <option value="btg_slot">
                                                        BTG
                                                      </option>
                                                      <option value="pgsoft_slot">
                                                        PG소프트
                                                      </option>
                                                      <option value="aspect_slot">
                                                        아스펙트
                                                      </option>
                                                      <option value="betsoft_slot">
                                                        벳소프트 슬롯
                                                      </option>
                                                      <option value="skywind_slot">
                                                        스카이윈드 슬롯
                                                      </option>
                                                      <option value="ftg_slot">
                                                        FTG 슬롯
                                                      </option>
                                                      <option value="netgaming">
                                                        넷게이밍
                                                      </option>
                                                      <option value="ps_slot">
                                                        플레이스타 슬롯
                                                      </option>
                                                      <option value="naga_slot">
                                                        NAGA
                                                      </option>
                                                      <option value="nspin_slot">
                                                        넥스트스핀 슬롯
                                                      </option>
                                                      <option value="playngo_slot">
                                                        플레이앤고
                                                      </option>
                                                      <option value="evo_slot">
                                                        에보플레이 슬롯
                                                      </option>
                                                      <option value="aux_slot">
                                                        아바타UX 슬롯
                                                      </option>
                                                      <option value="relax_slot">
                                                        릴렉스
                                                      </option>
                                                      <option value="reelplay_slot">
                                                        릴플레이 슬롯
                                                      </option>
                                                      <option value="fantasma_slot">
                                                        판타즈마 슬롯
                                                      </option>
                                                      <option value="boomerang_slot">
                                                        부메랑 슬롯
                                                      </option>
                                                      <option value="4tp_slot">
                                                        포더플레이어 슬롯
                                                      </option>
                                                      <option value="nlc_slot">
                                                        노리밋시티 슬롯
                                                      </option>
                                                      <option value="hs_slot">
                                                        핵쏘우게이밍 슬롯
                                                      </option>
                                                      <option value="joker_slot">
                                                        조커 슬롯
                                                      </option>
                                                      <option value="jili_slot">
                                                        JILI 슬롯
                                                      </option>
                                                      <option value="funkygames_slot">
                                                        펀키게임즈 슬롯
                                                      </option>
                                                      <option value="bgaming_slot">
                                                        비게이밍 슬롯
                                                      </option>
                                                      <option value="booming_slot">
                                                        부밍게임즈 슬롯
                                                      </option>
                                                      <option value="expanse_slot">
                                                        익스팬스 슬롯
                                                      </option>
                                                      <option value="dragoonsoft_slot">
                                                        드래곤소프트
                                                      </option>
                                                      <option value="wazdan_slot">
                                                        와즈단
                                                      </option>
                                                      <option value="octoplay_slot">
                                                        옥토플레이
                                                      </option>
                                                      <option value="ygg_slot">
                                                        이그드라실
                                                      </option>
                                                      <option value="bt1_sports">
                                                        BT1
                                                      </option>
                                                    </select>
                                                  </div>
                                                </td>
                                                <td className="text-center align-middle">
                                                  String
                                                </td>
                                                <td className="text-center align-middle">
                                                  <span className="badge bg-info">
                                                    YES
                                                  </span>
                                                </td>
                                                <td>게임사 벤더키</td>
                                              </tr>
                                              <tr>
                                                <td className="align-middle">
                                                  <b>skin</b>
                                                </td>
                                                <td className="align-middle">
                                                  <div className="form-group align-middle">
                                                    <input
                                                      className="form-control"
                                                      type="text"
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center align-middle">
                                                  <div className="form-group align-middle">
                                                    <select className="form-select">
                                                      <option value="A">
                                                        1,000 ~ 5,000,000 ₩
                                                      </option>
                                                      <option value="B">
                                                        1,000 ~ 10,000,000 ₩
                                                      </option>
                                                      <option value="C">
                                                        1,000 ~ 30,000,000 ₩
                                                      </option>
                                                      <option value="D">
                                                        1,000 ~ 50,000,000 ₩
                                                      </option>
                                                      <option value="E">
                                                        1,000 ~ 100,000,000 ₩
                                                      </option>
                                                    </select>
                                                  </div>
                                                </td>
                                                <td className="text-center align-middle">
                                                  String
                                                </td>
                                                <td className="text-center align-middle">
                                                  <span className="badge bg-danger">
                                                    NO
                                                  </span>
                                                </td>
                                                <td>
                                                  skin 코드 (카지노 게임사 전용)
                                                  <br />
                                                  <b>
                                                    [부록 → 카지노 한도 스킨표]
                                                  </b>
                                                  에서 확인가능합니다
                                                  <br />
                                                </td>
                                              </tr>
                                              <tr>
                                                <td className="align-middle">
                                                  <b>type</b>
                                                </td>
                                                <td className="align-middle">
                                                  <div className="form-group align-middle">
                                                    <input
                                                      className="form-control"
                                                      disabled
                                                      type="text"
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center align-middle">
                                                  <div className="form-group align-middle">
                                                    <select
                                                      className="form-select"
                                                      disabled
                                                      id="selectType">
                                                      <option value="Slot">
                                                        Slot
                                                      </option>
                                                      <option value="Arcade">
                                                        Arcade
                                                      </option>
                                                      <option value="Fishing">
                                                        Fishing
                                                      </option>
                                                      <option value="Bingo">
                                                        Bingo
                                                      </option>
                                                      <option value="Table Games">
                                                        Table Games
                                                      </option>
                                                    </select>
                                                  </div>
                                                </td>
                                                <td className="text-center align-middle">
                                                  String
                                                </td>
                                                <td className="text-center align-middle">
                                                  <span className="badge bg-danger">
                                                    NO
                                                  </span>
                                                </td>
                                                <td>
                                                  게임타입 (슬롯 게임사 전용)
                                                  <br />
                                                  원하시는 게임타입을 지정하여
                                                  호출이 가능합니다
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                        <div className="form-group text-center">
                                          <button
                                            className="btn btn-primary btn-lg"
                                            type="submit">
                                            <i className="fas fa-paper-plane" />
                                            Request{" "}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-xl-4 col-xxl-4">
                                  <div className="p-1" id="menu3">
                                    <div className="card text-bg-light">
                                      <div className="card-header">
                                        <h5>CODE</h5>
                                      </div>
                                      <div className="card-body">
                                        <ul
                                          className="nav nav-tabs nav-pills mb-3"
                                          id="animateLine"
                                          role="tablist">
                                          <li className="nav-item">
                                            <button
                                              className="nav-link active"
                                              data-bs-target="#tab-menu5-games"
                                              data-bs-toggle="tab"
                                              id="home-tab"
                                              type="button">
                                              {" "}
                                              Res Data{" "}
                                            </button>
                                          </li>
                                          <li className="nav-item">
                                            <button
                                              className="nav-link"
                                              data-bs-target="#tab-menu1-games"
                                              data-bs-toggle="tab"
                                              id="home-tab"
                                              type="button">
                                              {" "}
                                              NodeJs{" "}
                                            </button>
                                          </li>
                                          <li className="nav-item">
                                            <button
                                              className="nav-link"
                                              data-bs-target="#tab-menu2-games"
                                              data-bs-toggle="tab">
                                              {" "}
                                              PHP{" "}
                                            </button>
                                          </li>
                                          <li className="nav-item">
                                            <button
                                              className="nav-link"
                                              data-bs-target="#tab-menu3-games"
                                              data-bs-toggle="tab">
                                              {" "}
                                              Java{" "}
                                            </button>
                                          </li>
                                          <li className="nav-item">
                                            <button
                                              className="nav-link"
                                              data-bs-target="#tab-menu4-games"
                                              data-bs-toggle="tab">
                                              {" "}
                                              Asp{" "}
                                            </button>
                                          </li>
                                        </ul>
                                        <div
                                          className="tab-content"
                                          id="iconTabContent-1">
                                          <div
                                            className="tab-pane fade show active"
                                            id="tab-menu5-games">
                                            <pre className="rounded-lg">
                                              <code className="javascript hljs">
                                                {`{  `}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "code"
                                                    </span>
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-number">
                                                  <span className="hljs-number">
                                                    <span className="hljs-number">
                                                      0
                                                    </span>
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      // 0: 정상, -1: 오류
                                                      메시지 확인
                                                    </span>
                                                  </span>
                                                </span>
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "games"
                                                    </span>
                                                  </span>
                                                </span>
                                                {`: [	{	  `}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "row_num"
                                                    </span>
                                                  </span>
                                                </span>{" "}
                                                :{" "}
                                                <span className="hljs-number">
                                                  <span className="hljs-number">
                                                    <span className="hljs-number">
                                                      1
                                                    </span>
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      // Record number(정렬순)
                                                    </span>
                                                  </span>
                                                </span>
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "id"
                                                    </span>
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-number">
                                                  <span className="hljs-number">
                                                    <span className="hljs-number">
                                                      000
                                                    </span>
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      // 게임 아이디
                                                    </span>
                                                  </span>
                                                </span>
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "skin"
                                                    </span>
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "A"
                                                    </span>
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      // 스킨
                                                    </span>
                                                  </span>
                                                </span>
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "key"
                                                    </span>
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "qiqqwt5d2uibl3gk"
                                                    </span>
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      // 게임키
                                                    </span>
                                                  </span>
                                                </span>
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "names"
                                                    </span>
                                                  </span>
                                                </span>
                                                {`: {		  `}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "ko"
                                                    </span>
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "Speed VIP Blackjack F"
                                                    </span>
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      // 게임명 (한글)
                                                    </span>
                                                  </span>
                                                </span>
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "en"
                                                    </span>
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "Speed VIP Blackjack F"
                                                    </span>
                                                  </span>
                                                </span>
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      // 게임명 (영문)
                                                    </span>
                                                  </span>
                                                </span>
                                                {`		},	  `}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "platform"
                                                    </span>
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "html5"
                                                    </span>
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      // Platform
                                                    </span>
                                                  </span>
                                                </span>
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "category"
                                                    </span>
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "casino"
                                                    </span>
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      // 게임 구분
                                                    </span>
                                                  </span>
                                                </span>
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "type"
                                                    </span>
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "Blackjack"
                                                    </span>
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      // 게임 형식
                                                    </span>
                                                  </span>
                                                </span>
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "image"
                                                    </span>
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      ""
                                                    </span>
                                                  </span>
                                                </span>
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      // 게임 이미지
                                                    </span>
                                                  </span>
                                                </span>
                                                {`	}	...  ]}																										`}
                                              </code>
                                            </pre>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="tab-menu1-games">
                                            <pre className="rounded-lg">
                                              <code className="javascript hljs">
                                                <span className="hljs-keyword">
                                                  <span className="hljs-keyword">
                                                    <span className="hljs-keyword">
                                                      var
                                                    </span>
                                                  </span>
                                                </span>{" "}
                                                axios ={" "}
                                                <span className="hljs-built_in">
                                                  <span className="hljs-built_in">
                                                    <span className="hljs-built_in">
                                                      require
                                                    </span>
                                                  </span>
                                                </span>
                                                (
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      'axios'
                                                    </span>
                                                  </span>
                                                </span>
                                                );
                                                <span className="hljs-keyword">
                                                  <span className="hljs-keyword">
                                                    <span className="hljs-keyword">
                                                      var
                                                    </span>
                                                  </span>
                                                </span>{" "}
                                                qs ={" "}
                                                <span className="hljs-built_in">
                                                  <span className="hljs-built_in">
                                                    <span className="hljs-built_in">
                                                      require
                                                    </span>
                                                  </span>
                                                </span>
                                                (
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      'qs'
                                                    </span>
                                                  </span>
                                                </span>
                                                );
                                                <span className="hljs-keyword">
                                                  <span className="hljs-keyword">
                                                    <span className="hljs-keyword">
                                                      var
                                                    </span>
                                                  </span>
                                                </span>
                                                {` data = qs.stringify({  `}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      'vendorKey'
                                                    </span>
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      'evolution-n'
                                                    </span>
                                                  </span>
                                                </span>
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      'skin'
                                                    </span>
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      'A'
                                                    </span>
                                                  </span>
                                                </span>
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      'type'
                                                    </span>
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      ''
                                                    </span>
                                                  </span>
                                                </span>
                                                {`});`}
                                                <span className="hljs-keyword">
                                                  <span className="hljs-keyword">
                                                    <span className="hljs-keyword">
                                                      var
                                                    </span>
                                                  </span>
                                                </span>
                                                {` config = {  `}
                                                <span className="hljs-attr">
                                                  <span className="hljs-attr">
                                                    <span className="hljs-attr">
                                                      method
                                                    </span>
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      'post'
                                                    </span>
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-attr">
                                                  <span className="hljs-attr">
                                                    <span className="hljs-attr">
                                                      url
                                                    </span>
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      'API 요청 URL/games'
                                                    </span>
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-attr">
                                                  <span className="hljs-attr">
                                                    <span className="hljs-attr">
                                                      headers
                                                    </span>
                                                  </span>
                                                </span>
                                                {`: {	`}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      'agent'
                                                    </span>
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      'Matrixgames'
                                                    </span>
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      'secretKey'
                                                    </span>
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      'ce3da8a33f5f6dae8620f3126ac6cd0b'
                                                    </span>
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      'User-agent'
                                                    </span>
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      'Mozilla'
                                                    </span>
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      'hash'
                                                    </span>
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      'null'
                                                    </span>
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      'Content-Type'
                                                    </span>
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      'application/x-www-form-urlencoded'
                                                    </span>
                                                  </span>
                                                </span>
                                                {`  },  `}
                                                <span className="hljs-attr">
                                                  <span className="hljs-attr">
                                                    <span className="hljs-attr">
                                                      data
                                                    </span>
                                                  </span>
                                                </span>
                                                {` : data};axios(config).then(`}
                                                <span className="hljs-function">
                                                  <span className="hljs-keyword">
                                                    <span className="hljs-function">
                                                      <span className="hljs-keyword">
                                                        <span className="hljs-function">
                                                          <span className="hljs-keyword">
                                                            function
                                                          </span>
                                                        </span>
                                                      </span>
                                                    </span>
                                                  </span>
                                                  <span className="hljs-function">
                                                    <span className="hljs-function">
                                                      {" "}
                                                      (
                                                    </span>
                                                  </span>
                                                  <span className="hljs-params">
                                                    <span className="hljs-function">
                                                      <span className="hljs-params">
                                                        <span className="hljs-function">
                                                          <span className="hljs-params">
                                                            response
                                                          </span>
                                                        </span>
                                                      </span>
                                                    </span>
                                                  </span>
                                                  <span className="hljs-function">
                                                    <span className="hljs-function">
                                                      ){" "}
                                                    </span>
                                                  </span>
                                                </span>
                                                {`{  `}
                                                <span className="hljs-built_in">
                                                  <span className="hljs-built_in">
                                                    <span className="hljs-built_in">
                                                      console
                                                    </span>
                                                  </span>
                                                </span>
                                                .log(
                                                <span className="hljs-built_in">
                                                  <span className="hljs-built_in">
                                                    <span className="hljs-built_in">
                                                      JSON
                                                    </span>
                                                  </span>
                                                </span>
                                                {`.stringify(response.data));}).catch(`}
                                                <span className="hljs-function">
                                                  <span className="hljs-keyword">
                                                    <span className="hljs-function">
                                                      <span className="hljs-keyword">
                                                        <span className="hljs-function">
                                                          <span className="hljs-keyword">
                                                            function
                                                          </span>
                                                        </span>
                                                      </span>
                                                    </span>
                                                  </span>
                                                  <span className="hljs-function">
                                                    <span className="hljs-function">
                                                      {" "}
                                                      (
                                                    </span>
                                                  </span>
                                                  <span className="hljs-params">
                                                    <span className="hljs-function">
                                                      <span className="hljs-params">
                                                        <span className="hljs-function">
                                                          <span className="hljs-params">
                                                            error
                                                          </span>
                                                        </span>
                                                      </span>
                                                    </span>
                                                  </span>
                                                  <span className="hljs-function">
                                                    <span className="hljs-function">
                                                      ){" "}
                                                    </span>
                                                  </span>
                                                </span>
                                                {`{  `}
                                                <span className="hljs-built_in">
                                                  <span className="hljs-built_in">
                                                    <span className="hljs-built_in">
                                                      console
                                                    </span>
                                                  </span>
                                                </span>
                                                {`.log(error);});																										`}
                                              </code>
                                            </pre>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="tab-menu2-games">
                                            <pre className="rounded-lg">
                                              <code className="php hljs">
                                                <span className="hljs-meta">
                                                  <span className="hljs-meta">
                                                    <span className="hljs-meta">
                                                      {`<?php`}
                                                    </span>
                                                  </span>
                                                </span>
                                                <span className="hljs-variable">
                                                  <span className="hljs-variable">
                                                    <span className="hljs-variable">
                                                      $curl
                                                    </span>
                                                  </span>
                                                </span>{" "}
                                                = curl_init();curl_setopt_array(
                                                <span className="hljs-variable">
                                                  <span className="hljs-variable">
                                                    <span className="hljs-variable">
                                                      $curl
                                                    </span>
                                                  </span>
                                                </span>
                                                ,{" "}
                                                <span className="hljs-keyword">
                                                  <span className="hljs-keyword">
                                                    <span className="hljs-keyword">
                                                      array
                                                    </span>
                                                  </span>
                                                </span>
                                                {`(  CURLOPT_URL => `}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      'API 요청 URL/games'
                                                    </span>
                                                  </span>
                                                </span>
                                                {`,  CURLOPT_RETURNTRANSFER => `}
                                                <span className="hljs-literal">
                                                  <span className="hljs-literal">
                                                    <span className="hljs-literal">
                                                      true
                                                    </span>
                                                  </span>
                                                </span>
                                                {`,  CURLOPT_ENCODING => `}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      ''
                                                    </span>
                                                  </span>
                                                </span>
                                                {`,  CURLOPT_MAXREDIRS => `}
                                                <span className="hljs-number">
                                                  <span className="hljs-number">
                                                    <span className="hljs-number">
                                                      10
                                                    </span>
                                                  </span>
                                                </span>
                                                {`,  CURLOPT_TIMEOUT => `}
                                                <span className="hljs-number">
                                                  <span className="hljs-number">
                                                    <span className="hljs-number">
                                                      0
                                                    </span>
                                                  </span>
                                                </span>
                                                {`,  CURLOPT_FOLLOWLOCATION => `}
                                                <span className="hljs-literal">
                                                  <span className="hljs-literal">
                                                    <span className="hljs-literal">
                                                      true
                                                    </span>
                                                  </span>
                                                </span>
                                                {`,  CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,  CURLOPT_CUSTOMREQUEST => `}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      'POST'
                                                    </span>
                                                  </span>
                                                </span>
                                                {`,  CURLOPT_POSTFIELDS => `}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      'vendorKey=evolution-n&skin=A&type='
                                                    </span>
                                                  </span>
                                                </span>
                                                {`,  CURLOPT_HTTPHEADER => `}
                                                <span className="hljs-keyword">
                                                  <span className="hljs-keyword">
                                                    <span className="hljs-keyword">
                                                      array
                                                    </span>
                                                  </span>
                                                </span>
                                                (
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      'agent: Matrixgames'
                                                    </span>
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      'secretKey:
                                                      ce3da8a33f5f6dae8620f3126ac6cd0b'
                                                    </span>
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      'User-agent: Mozilla'
                                                    </span>
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      'hash: null'
                                                    </span>
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      'Content-Type:
                                                      application/x-www-form-urlencoded'
                                                    </span>
                                                  </span>
                                                </span>
                                                ),));
                                                <span className="hljs-variable">
                                                  <span className="hljs-variable">
                                                    <span className="hljs-variable">
                                                      $response
                                                    </span>
                                                  </span>
                                                </span>{" "}
                                                = curl_exec(
                                                <span className="hljs-variable">
                                                  <span className="hljs-variable">
                                                    <span className="hljs-variable">
                                                      $curl
                                                    </span>
                                                  </span>
                                                </span>
                                                );curl_close(
                                                <span className="hljs-variable">
                                                  <span className="hljs-variable">
                                                    <span className="hljs-variable">
                                                      $curl
                                                    </span>
                                                  </span>
                                                </span>
                                                );
                                                <span className="hljs-keyword">
                                                  <span className="hljs-keyword">
                                                    <span className="hljs-keyword">
                                                      echo
                                                    </span>
                                                  </span>
                                                </span>{" "}
                                                <span className="hljs-variable">
                                                  <span className="hljs-variable">
                                                    <span className="hljs-variable">
                                                      $response
                                                    </span>
                                                  </span>
                                                </span>
                                                ;
                                              </code>
                                            </pre>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="tab-menu3-games">
                                            <pre className="rounded-lg">
                                              <code className="java hljs">
                                                OkHttpClient client ={" "}
                                                <span className="hljs-keyword">
                                                  <span className="hljs-keyword">
                                                    <span className="hljs-keyword">
                                                      new
                                                    </span>
                                                  </span>
                                                </span>{" "}
                                                OkHttpClient().newBuilder().build();MediaType
                                                mediaType = MediaType.parse(
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "application/x-www-form-urlencoded"
                                                    </span>
                                                  </span>
                                                </span>
                                                );RequestBody body =
                                                RequestBody.create(mediaType,{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "vendorKey=evolution-n&skin=A&type="
                                                    </span>
                                                  </span>
                                                </span>
                                                );Request request ={" "}
                                                <span className="hljs-keyword">
                                                  <span className="hljs-keyword">
                                                    <span className="hljs-keyword">
                                                      new
                                                    </span>
                                                  </span>
                                                </span>{" "}
                                                Request.Builder() .url(
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "API 요청 URL/games"
                                                    </span>
                                                  </span>
                                                </span>
                                                ) .method(
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "POST"
                                                    </span>
                                                  </span>
                                                </span>
                                                , body) .addHeader(
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "agent"
                                                    </span>
                                                  </span>
                                                </span>
                                                ,{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "Matrixgames"
                                                    </span>
                                                  </span>
                                                </span>
                                                ) .addHeader(
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "secretKey"
                                                    </span>
                                                  </span>
                                                </span>
                                                ,{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "ce3da8a33f5f6dae8620f3126ac6cd0b"
                                                    </span>
                                                  </span>
                                                </span>
                                                ) .addHeader(
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "User-agent"
                                                    </span>
                                                  </span>
                                                </span>
                                                ,{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "Mozilla"
                                                    </span>
                                                  </span>
                                                </span>
                                                ) .addHeader(
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "hash"
                                                    </span>
                                                  </span>
                                                </span>
                                                ,{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "null"
                                                    </span>
                                                  </span>
                                                </span>
                                                ) .addHeader(
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "Content-Type"
                                                    </span>
                                                  </span>
                                                </span>
                                                ,{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    <span className="hljs-string">
                                                      "application/x-www-form-urlencoded"
                                                    </span>
                                                  </span>
                                                </span>
                                                ) .build();Response response =
                                                client.newCall(request).execute();
                                              </code>
                                            </pre>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="tab-menu4-games">
                                            <pre className="rounded-lg">
                                              <code className="asp hljs gams">
                                                {`<%`}
                                                <span className="hljs-keyword">
                                                  <span className="hljs-keyword">
                                                    <span className="hljs-keyword">
                                                      set
                                                    </span>
                                                  </span>
                                                </span>{" "}
                                                req{" "}
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      = Server.CreateObject(
                                                    </span>
                                                  </span>
                                                </span>
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      "MSXML2.ServerXMLHTTP"
                                                    </span>
                                                  </span>
                                                </span>
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      )
                                                    </span>
                                                  </span>
                                                </span>
                                                req.open{" "}
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      "POST"
                                                    </span>
                                                  </span>
                                                </span>
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      ,
                                                    </span>
                                                  </span>
                                                </span>{" "}
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      "API 요청 URL/games"
                                                    </span>
                                                  </span>
                                                </span>
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      , False
                                                    </span>
                                                  </span>
                                                </span>
                                                req.setRequestHeader{" "}
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      "accept"
                                                    </span>
                                                  </span>
                                                </span>
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      ,
                                                    </span>
                                                  </span>
                                                </span>{" "}
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      "application/json"
                                                    </span>
                                                  </span>
                                                </span>
                                                req.setRequestHeader{" "}
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      "Content-Type"
                                                    </span>
                                                  </span>
                                                </span>
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      ,
                                                    </span>
                                                  </span>
                                                </span>{" "}
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      "application/x-www-form-urlencoded"
                                                    </span>
                                                  </span>
                                                </span>
                                                req.setRequestHeader{" "}
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      "agent"
                                                    </span>
                                                  </span>
                                                </span>
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      ,
                                                    </span>
                                                  </span>
                                                </span>
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      "Matrixgames"
                                                    </span>
                                                  </span>
                                                </span>{" "}
                                                req.setRequestHeader{" "}
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      "secretKey"
                                                    </span>
                                                  </span>
                                                </span>
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      ,
                                                    </span>
                                                  </span>
                                                </span>{" "}
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      "ce3da8a33f5f6dae8620f3126ac6cd0b"
                                                    </span>
                                                  </span>
                                                </span>{" "}
                                                req.setRequestHeader{" "}
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      "hash"
                                                    </span>
                                                  </span>
                                                </span>
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      ,
                                                    </span>
                                                  </span>
                                                </span>{" "}
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      "null"
                                                    </span>
                                                  </span>
                                                </span>{" "}
                                                req.send{" "}
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      "vendorKey=evolution-n&skin=A&type="
                                                    </span>
                                                  </span>
                                                </span>
                                                data{" "}
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    <span className="hljs-comment">
                                                      = req.responseText
                                                    </span>
                                                  </span>
                                                </span>
                                                {`%>																										`}
                                              </code>
                                            </pre>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="p-1" id="menu4">
                                <div className="card text-bg-light">
                                  <div className="card-header">
                                    <h5>RESPONSE</h5>
                                  </div>
                                  <div className="card-body">
                                    <h6 className="mt-1 card-subtitle mb-2 text-body-secondary">
                                      <span className="text-primary">
                                        Response info
                                      </span>
                                    </h6>
                                    <div className="table-responsive">
                                      <table className="table mb-2">
                                        <colgroup>
                                          <col />
                                          <col />
                                          <col />
                                        </colgroup>
                                        <thead>
                                          <tr>
                                            <th className="text-center">
                                              Field
                                            </th>
                                            <th className="text-center">
                                              Type
                                            </th>
                                            <th className="text-center">
                                              Value
                                            </th>
                                            <th className="text-center">
                                              Desc
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <b>code</b>
                                            </td>
                                            <td>Number</td>
                                            <td>0</td>
                                            <td>
                                              0: 정상, -1: 오류 메시지 확인
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <b>msg</b>
                                            </td>
                                            <td>String</td>
                                            <td>오류 메시지</td>
                                            <td>오류 메시지</td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <b>games</b>
                                            </td>
                                            <td>Array</td>
                                            <td>
                                              {" "}
                                              row_num : Record number(정렬순)
                                              <br /> id : 게임 아이디
                                              <br /> skin : 스킨
                                              <br /> key : 게임키
                                              <br /> names.ko : 게임명 (한글)
                                              <br /> names.en : 게임명 (영문)
                                              <br /> platform : Platform
                                              <br /> category : 게임 구분
                                              <br /> type : 게임 형식
                                              <br /> image : 게임 이미지
                                              <br />
                                            </td>
                                            <td>게임 목록</td>
                                          </tr>
                                        </tbody>
                                      </table>
                                      <h6 className="mt-1 card-subtitle mb-2 text-body-secondary">
                                        <span className="text-primary">
                                          Response Data
                                        </span>
                                      </h6>
                                      <div className="form-group">
                                        <pre
                                          className="rounded-lg text-white"
                                          style={{
                                            backgroundColor: "black",
                                            height: "300px",
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card card-bordered m-3 mb-4">
            <div className="card-inner-group">
              <div className="card-inner p-3">
                <div className="card">
                  <div className="row p-0 pointer">
                    <div className="col text-primary h5 m-0">
                      {" "}
                      3. 회원가입{" "}
                      <span className="badge badge-dim bg-outline-danger me-1">
                        필수
                      </span>
                    </div>
                    <div className="col-auto text-end">
                      <i className="fas fa-chevron-circle-up col text-primary" />
                    </div>
                  </div>
                  <div
                    className="col-sm-12 col-md-12 bg-primary mt-2"
                    style={{
                      height: "1px",
                    }}
                  />
                  <div className="row">
                    <div className="col-sm-12 col-md-12 p-4">
                      <div className="nk-block vApiSignup">
                        <div className="card">
                          <div className="row">
                            <div className="col-sm-12 col-md-12">
                              <div className="p-1" id="menu1">
                                <div className="card text-bg-light">
                                  <div className="card-header">
                                    <h5>Info</h5>
                                  </div>
                                  <div className="card-body">
                                    <dd>신규 회원을 등록합니다</dd>
                                    <dd>
                                      전체 회원을 등록하는 것이 아닌, 반드시
                                      실제로 사용하는 유저만 건별로 등록해주세요
                                    </dd>
                                    <dd />
                                    <dd>
                                      당사는 회원가입 시 입력된 username 앞에
                                      특정 값을 추가하여, 각 회원에게 고유한
                                      식별자를 부여하고 있습니다
                                    </dd>
                                    <dd>
                                      이를 통해 중복된 회원정보를 방지하고, 각
                                      회원을 유일하게 구분합니다
                                    </dd>
                                    <dd>
                                      예를 들어, 사용자가 \`testUser\`라는
                                      username으로 회원가입을 한다면, 당사는
                                      \`nx__prefix_testUser\`와 같이 특정 값인
                                      \`nx__prefix_\`를 username 앞에 추가하여
                                      해당 사용자에게 고유한 값을 부여합니다
                                    </dd>
                                    <dd>
                                      이런 방식을 통해 각 회원은 \`testUser\`가
                                      아닌 \`nx__prefix_testUser\`와 같은 형태로
                                      식별됩니다
                                    </dd>
                                    <dd>
                                      <span className="text-danger">
                                        회원가입시 아이디 값에 특수문자를
                                        입력하지마세요
                                      </span>
                                    </dd>
                                    <dd>
                                      <span className="text-danger">
                                        한글은 사용하실수 없습니다
                                      </span>
                                    </dd>
                                    <dd>
                                      <span className="text-danger">
                                        특수 문자 입력시 게임사 게임이용시
                                        제약이 될수있습니다
                                      </span>
                                    </dd>
                                    <dd>
                                      <small className="text-danger">
                                        * 회원가입 후 \`username\`은 위 내용과
                                        같이 게임이용에 있어 유일한 아이디로
                                        활용되오니 참고하시기 바랍니다
                                      </small>
                                    </dd>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-12 col-xl-6 col-xxl-8">
                                  <div className="p-1" id="menu2">
                                    <div className="card text-bg-light">
                                      <div className="card-header">
                                        <h5>API Data</h5>
                                      </div>
                                      <div className="card-body">
                                        <h6 className="mt-1 card-subtitle mb-2 text-body-secondary">
                                          <span className="text-primary">
                                            Request Url
                                          </span>
                                        </h6>
                                        <input
                                          className="form-control"
                                          disabled
                                          type="text"
                                        />
                                        <hr />
                                        <h6 className="mt-1 card-subtitle mb-2 text-body-secondary">
                                          <span className="text-primary">
                                            Header Data
                                          </span>
                                        </h6>
                                        <div className="table-responsive">
                                          <table className="table table-primary mb-2">
                                            <colgroup>
                                              <col />
                                              <col />
                                              <col />
                                              <col />
                                              <col />
                                            </colgroup>
                                            <thead>
                                              <tr>
                                                <th className="text-center">
                                                  <b>Field</b>
                                                </th>
                                                <th className="text-center">
                                                  <b>Value</b>
                                                </th>
                                                <th className="text-center">
                                                  <b>Required</b>
                                                </th>
                                                <th className="text-center">
                                                  <b>Desc</b>
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr>
                                                <td>
                                                  <b>method</b>
                                                </td>
                                                <td>
                                                  <div className="form-group">
                                                    <input
                                                      className="form-control"
                                                      disabled
                                                      type="text"
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center">
                                                  <span className="badge bg-info">
                                                    YES
                                                  </span>
                                                </td>
                                                <td>POST</td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <b>accept</b>
                                                </td>
                                                <td>
                                                  <div className="form-group">
                                                    <input
                                                      className="form-control"
                                                      disabled
                                                      type="text"
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center">
                                                  <span className="badge bg-info">
                                                    YES
                                                  </span>
                                                </td>
                                                <td>Application type</td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <b>content-type</b>
                                                </td>
                                                <td>
                                                  <div className="form-group">
                                                    <input
                                                      className="form-control"
                                                      disabled
                                                      type="text"
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center">
                                                  <span className="badge bg-info">
                                                    YES
                                                  </span>
                                                </td>
                                                <td>Application</td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <b>hash</b>
                                                </td>
                                                <td>
                                                  <div className="form-group">
                                                    <input
                                                      className="form-control"
                                                      disabled
                                                      type="text"
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center">
                                                  <span className="badge bg-info">
                                                    YES
                                                  </span>
                                                </td>
                                                <td>hash</td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <b>agent</b>
                                                </td>
                                                <td>
                                                  <div className="form-group">
                                                    <input
                                                      className="form-control"
                                                      disabled
                                                      type="text"
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center">
                                                  <span className="badge bg-info">
                                                    YES
                                                  </span>
                                                </td>
                                                <td>에이전트 아이디</td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                        <h6 className="mt-1 card-subtitle mb-2 text-body-secondary">
                                          <span className="text-primary">
                                            Body Data
                                          </span>
                                        </h6>
                                        <div className="table-responsive">
                                          <table className="table mb-2">
                                            <colgroup>
                                              <col />
                                              <col />
                                              <col />
                                              <col />
                                              <col />
                                            </colgroup>
                                            <thead>
                                              <tr>
                                                <th className="text-center">
                                                  <b>Field</b>
                                                </th>
                                                <th className="text-center">
                                                  <b>Value</b>
                                                </th>
                                                <th className="text-center">
                                                  <b>Type</b>
                                                </th>
                                                <th className="text-center">
                                                  <b>Required</b>
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-bs-placement="top"
                                                  data-bs-toggle="tooltip"
                                                  title="문자열 처리 과정에서 byte 처리에 오류가 발생할 가능성을 고려하여, 글자 수를 기준으로 처리하고 있습니다">
                                                  <b>Length</b>
                                                  <em className="icon ni ni-info-fill vam" />
                                                </th>
                                                <th className="text-center">
                                                  <b>Desc</b>
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr>
                                                <td>
                                                  <b>username</b>
                                                </td>
                                                <td>
                                                  <div className="form-group">
                                                    <input
                                                      className="form-control"
                                                      type="text"
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center">
                                                  String
                                                </td>
                                                <td className="text-center">
                                                  <span className="badge bg-info">
                                                    YES
                                                  </span>
                                                </td>
                                                <td className="text-center">
                                                  <div className="form-group">
                                                    <span>3글자 ~ </span>
                                                    <span>22글자</span>
                                                  </div>
                                                </td>
                                                <td>
                                                  API용 회원 아이디 (게임을 위한
                                                  고유한 회원 식별자입니다)
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <b>nickname</b>
                                                </td>
                                                <td>
                                                  <div className="form-group">
                                                    <input
                                                      className="form-control"
                                                      type="text"
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center">
                                                  String
                                                </td>
                                                <td className="text-center">
                                                  <span className="badge bg-info">
                                                    YES
                                                  </span>
                                                </td>
                                                <td className="text-center">
                                                  <div className="form-group">
                                                    <span>2글자 ~ </span>
                                                    <span>22글자</span>
                                                  </div>
                                                </td>
                                                <td>
                                                  사이트 닉네임 (게임 중에 다른
                                                  플레이어에게 보여지는 회원의
                                                  닉네임입니다)
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <b>siteUsername</b>
                                                </td>
                                                <td>
                                                  <div className="form-group">
                                                    <input
                                                      className="form-control"
                                                      type="text"
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center">
                                                  String
                                                </td>
                                                <td className="text-center">
                                                  <span className="badge bg-info">
                                                    YES
                                                  </span>
                                                </td>
                                                <td className="text-center">
                                                  <div className="form-group">
                                                    <span>3글자 ~ </span>
                                                    <span>22글자</span>
                                                  </div>
                                                </td>
                                                <td>
                                                  사이트 회원아이디
                                                  (실사이트에서 사용하는 고유
                                                  회원 아이디)
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                        <div className="form-group text-center">
                                          <button
                                            className="btn btn-primary btn-lg"
                                            type="submit">
                                            <i className="fas fa-paper-plane" />
                                            Request{" "}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-12 col-xl-6 col-xxl-4">
                                  <div className="p-1" id="menu3">
                                    <div className="card text-bg-light">
                                      <div className="card-header">
                                        <h5>CODE</h5>
                                      </div>
                                      <div className="card-body">
                                        <ul
                                          className="nav nav-tabs nav-pills mb-3"
                                          id="animateLine"
                                          role="tablist">
                                          <li className="nav-item">
                                            <button
                                              className="nav-link active"
                                              data-bs-target="#tab-menu5-signup"
                                              data-bs-toggle="tab"
                                              id="home-tab"
                                              type="button">
                                              {" "}
                                              Res Data{" "}
                                            </button>
                                          </li>
                                          <li className="nav-item">
                                            <button
                                              className="nav-link"
                                              data-bs-target="#tab-menu1-signup"
                                              data-bs-toggle="tab"
                                              id="home-tab"
                                              type="button">
                                              {" "}
                                              NodeJs{" "}
                                            </button>
                                          </li>
                                          <li className="nav-item">
                                            <button
                                              className="nav-link"
                                              data-bs-target="#tab-menu2-signup"
                                              data-bs-toggle="tab">
                                              {" "}
                                              PHP{" "}
                                            </button>
                                          </li>
                                          <li className="nav-item">
                                            <button
                                              className="nav-link"
                                              data-bs-target="#tab-menu3-signup"
                                              data-bs-toggle="tab">
                                              {" "}
                                              Java{" "}
                                            </button>
                                          </li>
                                          <li className="nav-item">
                                            <button
                                              className="nav-link"
                                              data-bs-target="#tab-menu4-signup"
                                              data-bs-toggle="tab">
                                              {" "}
                                              Asp{" "}
                                            </button>
                                          </li>
                                        </ul>
                                        <div
                                          className="tab-content"
                                          id="iconTabContent-1">
                                          <div
                                            className="tab-pane fade show active"
                                            id="tab-menu5-signup">
                                            <pre className="rounded-lg">
                                              <code className="javascript hljs">
                                                {`{  `}
                                                <span className="hljs-string">
                                                  "code"
                                                </span>
                                                :{" "}
                                                <span className="hljs-number">
                                                  0
                                                </span>{" "}
                                                <span className="hljs-comment">
                                                  // 0: 정상, -1: 오류 메시지
                                                  확인
                                                </span>
                                                {`}																										`}
                                              </code>
                                            </pre>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="tab-menu1-signup">
                                            <pre className="rounded-lg">
                                              <code className="javascript hljs">
                                                <span className="hljs-keyword">
                                                  var
                                                </span>{" "}
                                                axios ={" "}
                                                <span className="hljs-built_in">
                                                  require
                                                </span>
                                                (
                                                <span className="hljs-string">
                                                  'axios'
                                                </span>
                                                );
                                                <span className="hljs-keyword">
                                                  var
                                                </span>{" "}
                                                qs ={" "}
                                                <span className="hljs-built_in">
                                                  require
                                                </span>
                                                (
                                                <span className="hljs-string">
                                                  'qs'
                                                </span>
                                                );
                                                <span className="hljs-keyword">
                                                  var
                                                </span>
                                                {` data = qs.stringify({  `}
                                                <span className="hljs-string">
                                                  'username'
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  'UserID'
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  'nickname'
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  'SiteNickname'
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  'siteUsername'
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  'SiteID'
                                                </span>
                                                {`,});`}
                                                <span className="hljs-keyword">
                                                  var
                                                </span>
                                                {` config = {  `}
                                                <span className="hljs-attr">
                                                  method
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  'post'
                                                </span>
                                                ,
                                                <span className="hljs-attr">
                                                  url
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  'API 요청 URL/register'
                                                </span>
                                                ,
                                                <span className="hljs-attr">
                                                  headers
                                                </span>
                                                {`: {	`}
                                                <span className="hljs-string">
                                                  'agent'
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  'Matrixgames'
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  'secretKey'
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  'ce3da8a33f5f6dae8620f3126ac6cd0b'
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  'User-agent'
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  'Mozilla'
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  'hash'
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  'null'
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  'Content-Type'
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  'application/x-www-form-urlencoded'
                                                </span>
                                                {`  },  `}
                                                <span className="hljs-attr">
                                                  data
                                                </span>
                                                {` : data};axios(config).then(`}
                                                <span className="hljs-function">
                                                  <span className="hljs-keyword">
                                                    function
                                                  </span>{" "}
                                                  (
                                                  <span className="hljs-params">
                                                    response
                                                  </span>
                                                  ){" "}
                                                </span>
                                                {`{  `}
                                                <span className="hljs-built_in">
                                                  console
                                                </span>
                                                .log(
                                                <span className="hljs-built_in">
                                                  JSON
                                                </span>
                                                {`.stringify(response.data));}).catch(`}
                                                <span className="hljs-function">
                                                  <span className="hljs-keyword">
                                                    function
                                                  </span>{" "}
                                                  (
                                                  <span className="hljs-params">
                                                    error
                                                  </span>
                                                  ){" "}
                                                </span>
                                                {`{  `}
                                                <span className="hljs-built_in">
                                                  console
                                                </span>
                                                {`.log(error);});																										`}
                                              </code>
                                            </pre>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="tab-menu2-signup">
                                            <pre className="rounded-lg">
                                              <code className="php hljs">
                                                <span className="hljs-meta">
                                                  {`<?php`}
                                                </span>
                                                <span className="hljs-variable">
                                                  $curl
                                                </span>{" "}
                                                = curl_init();curl_setopt_array(
                                                <span className="hljs-variable">
                                                  $curl
                                                </span>
                                                ,{" "}
                                                <span className="hljs-keyword">
                                                  array
                                                </span>
                                                {`(  CURLOPT_URL => `}
                                                <span className="hljs-string">
                                                  'API 요청 URL/register'
                                                </span>
                                                {`,  CURLOPT_RETURNTRANSFER => `}
                                                <span className="hljs-literal">
                                                  true
                                                </span>
                                                {`,  CURLOPT_ENCODING => `}
                                                <span className="hljs-string">
                                                  ''
                                                </span>
                                                {`,  CURLOPT_MAXREDIRS => `}
                                                <span className="hljs-number">
                                                  10
                                                </span>
                                                {`,  CURLOPT_TIMEOUT => `}
                                                <span className="hljs-number">
                                                  0
                                                </span>
                                                {`,  CURLOPT_FOLLOWLOCATION => `}
                                                <span className="hljs-literal">
                                                  true
                                                </span>
                                                {`,  CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,  CURLOPT_CUSTOMREQUEST => `}
                                                <span className="hljs-string">
                                                  'POST'
                                                </span>
                                                {`,  CURLOPT_POSTFIELDS => `}
                                                <span className="hljs-string">
                                                  'username=UserID&nickname=SiteNickname&siteUsername=SiteID'
                                                </span>
                                                {`,  CURLOPT_HTTPHEADER => `}
                                                <span className="hljs-keyword">
                                                  array
                                                </span>
                                                (
                                                <span className="hljs-string">
                                                  'agent: Matrixgames'
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  'secretKey:
                                                  ce3da8a33f5f6dae8620f3126ac6cd0b'
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  'User-agent: Mozilla'
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  'hash: null'
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  'Content-Type:
                                                  application/x-www-form-urlencoded'
                                                </span>
                                                ),));
                                                <span className="hljs-variable">
                                                  $response
                                                </span>{" "}
                                                = curl_exec(
                                                <span className="hljs-variable">
                                                  $curl
                                                </span>
                                                );curl_close(
                                                <span className="hljs-variable">
                                                  $curl
                                                </span>
                                                );
                                                <span className="hljs-keyword">
                                                  echo
                                                </span>{" "}
                                                <span className="hljs-variable">
                                                  $response
                                                </span>
                                                ;
                                              </code>
                                            </pre>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="tab-menu3-signup">
                                            <pre className="rounded-lg">
                                              <code className="java hljs">
                                                OkHttpClient client ={" "}
                                                <span className="hljs-keyword">
                                                  new
                                                </span>{" "}
                                                OkHttpClient().newBuilder().build();MediaType
                                                mediaType = MediaType.parse(
                                                <span className="hljs-string">
                                                  "application/x-www-form-urlencoded"
                                                </span>
                                                );RequestBody body =
                                                RequestBody.create(mediaType,{" "}
                                                <span className="hljs-string">
                                                  "username=UserID&nickname=SiteNickname&siteUsername=SiteID"
                                                </span>
                                                );Request request ={" "}
                                                <span className="hljs-keyword">
                                                  new
                                                </span>{" "}
                                                Request.Builder() .url(
                                                <span className="hljs-string">
                                                  "API 요청 URL/register"
                                                </span>
                                                ) .method(
                                                <span className="hljs-string">
                                                  "POST"
                                                </span>
                                                , body) .addHeader(
                                                <span className="hljs-string">
                                                  "agent"
                                                </span>
                                                ,{" "}
                                                <span className="hljs-string">
                                                  "Matrixgames"
                                                </span>
                                                ) .addHeader(
                                                <span className="hljs-string">
                                                  "secretKey"
                                                </span>
                                                ,{" "}
                                                <span className="hljs-string">
                                                  "ce3da8a33f5f6dae8620f3126ac6cd0b"
                                                </span>
                                                ) .addHeader(
                                                <span className="hljs-string">
                                                  "User-agent"
                                                </span>
                                                ,{" "}
                                                <span className="hljs-string">
                                                  "Mozilla"
                                                </span>
                                                ) .addHeader(
                                                <span className="hljs-string">
                                                  "hash"
                                                </span>
                                                ,{" "}
                                                <span className="hljs-string">
                                                  "null"
                                                </span>
                                                ) .addHeader(
                                                <span className="hljs-string">
                                                  "Content-Type"
                                                </span>
                                                ,{" "}
                                                <span className="hljs-string">
                                                  "application/x-www-form-urlencoded"
                                                </span>
                                                ) .build();Response response =
                                                client.newCall(request).execute();
                                              </code>
                                            </pre>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="tab-menu4-signup">
                                            <pre className="rounded-lg">
                                              <code className="asp hljs gams">
                                                {`<%`}
                                                <span className="hljs-keyword">
                                                  set
                                                </span>{" "}
                                                req{" "}
                                                <span className="hljs-comment">
                                                  = Server.CreateObject(
                                                </span>
                                                <span className="hljs-comment">
                                                  "MSXML2.ServerXMLHTTP"
                                                </span>
                                                <span className="hljs-comment">
                                                  )
                                                </span>
                                                req.open{" "}
                                                <span className="hljs-comment">
                                                  "POST"
                                                </span>
                                                <span className="hljs-comment">
                                                  ,
                                                </span>{" "}
                                                <span className="hljs-comment">
                                                  "API 요청 URL/register"
                                                </span>
                                                <span className="hljs-comment">
                                                  , False
                                                </span>
                                                req.setRequestHeader{" "}
                                                <span className="hljs-comment">
                                                  "accept"
                                                </span>
                                                <span className="hljs-comment">
                                                  ,
                                                </span>{" "}
                                                <span className="hljs-comment">
                                                  "application/json"
                                                </span>
                                                req.setRequestHeader{" "}
                                                <span className="hljs-comment">
                                                  "Content-Type"
                                                </span>
                                                <span className="hljs-comment">
                                                  ,
                                                </span>{" "}
                                                <span className="hljs-comment">
                                                  "application/x-www-form-urlencoded"
                                                </span>
                                                req.setRequestHeader{" "}
                                                <span className="hljs-comment">
                                                  "agent"
                                                </span>
                                                <span className="hljs-comment">
                                                  ,
                                                </span>
                                                <span className="hljs-comment">
                                                  "Matrixgames"
                                                </span>{" "}
                                                req.setRequestHeader{" "}
                                                <span className="hljs-comment">
                                                  "secretKey"
                                                </span>
                                                <span className="hljs-comment">
                                                  ,
                                                </span>{" "}
                                                <span className="hljs-comment">
                                                  "ce3da8a33f5f6dae8620f3126ac6cd0b"
                                                </span>{" "}
                                                req.setRequestHeader{" "}
                                                <span className="hljs-comment">
                                                  "hash"
                                                </span>
                                                <span className="hljs-comment">
                                                  ,
                                                </span>{" "}
                                                <span className="hljs-comment">
                                                  "null"
                                                </span>{" "}
                                                req.send{" "}
                                                <span className="hljs-comment">
                                                  "username=UserID&nickname=SiteNickname&siteUsername=SiteID"
                                                </span>
                                                data{" "}
                                                <span className="hljs-comment">
                                                  = req.responseText
                                                </span>
                                                {`%>																										`}
                                              </code>
                                            </pre>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="p-1" id="menu4">
                                <div className="card text-bg-light">
                                  <div className="card-header">
                                    <h5>RESPONSE</h5>
                                  </div>
                                  <div className="card-body">
                                    <h6 className="mt-1 card-subtitle mb-2 text-body-secondary">
                                      <span className="text-primary">
                                        Response info
                                      </span>
                                    </h6>
                                    <div className="table-responsive">
                                      <table className="table mb-2">
                                        <colgroup>
                                          <col />
                                          <col />
                                          <col />
                                        </colgroup>
                                        <thead>
                                          <tr>
                                            <th className="text-center">
                                              Field
                                            </th>
                                            <th className="text-center">
                                              Type
                                            </th>
                                            <th className="text-center">
                                              Value
                                            </th>
                                            <th className="text-center">
                                              Desc
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <b>code</b>
                                            </td>
                                            <td>Number</td>
                                            <td>0, -1</td>
                                            <td>
                                              0: 정상, -1: 오류 메시지 확인
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <b>msg</b>
                                            </td>
                                            <td>String</td>
                                            <td>오류 메시지</td>
                                            <td>오류 메시지</td>
                                          </tr>
                                        </tbody>
                                      </table>
                                      <h6 className="mt-1 card-subtitle mb-2 text-body-secondary">
                                        <span className="text-primary">
                                          Response Data
                                        </span>
                                      </h6>
                                      <div className="form-group">
                                        <pre className="rounded-lg">
                                          <code className="returnData json hljs" />
                                        </pre>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card card-bordered m-3 mb-4">
            <div className="card-inner-group">
              <div className="card-inner p-3">
                <div className="card">
                  <div className="row p-0 pointer">
                    <div className="col text-primary h5 m-0">
                      {" "}
                      4. 게임실행{" "}
                      <span className="badge badge-dim bg-outline-danger me-1">
                        필수
                      </span>
                    </div>
                    <div className="col-auto text-end">
                      <i className="fas fa-chevron-circle-up col text-primary" />
                    </div>
                  </div>
                  <div
                    className="col-sm-12 col-md-12 bg-primary mt-2"
                    style={{
                      height: "1px",
                    }}
                  />
                  <div className="row">
                    <div className="col-sm-12 col-md-12 p-4">
                      <div className="nk-block vApiPlay">
                        <div className="card">
                          <div className="row">
                            <div className="col-sm-12 col-md-12">
                              <div className="p-1" id="menu1">
                                <div className="card text-bg-light">
                                  <div className="card-header">
                                    <h5>Info</h5>
                                  </div>
                                  <div className="card-body">
                                    <dd>
                                      게임을 실행하는 URL을 받아올 수 있는
                                      API입니다
                                    </dd>
                                    <dd>
                                      반드시 회원가입API를 먼저
                                      호출해주셔야하며, 게임실행 성공시
                                      게임사에서 제공하는 게임 URL 정보를
                                      제공합니다
                                    </dd>
                                    <dd className="text-danger">
                                      requestKey 를 기준으로 같은 요청이
                                      왔는지를 검증합니다
                                    </dd>
                                    <dd>
                                      <small className="text-danger">
                                        * API를 호출한 후 1초 뒤에 재 호출할 수
                                        있습니다 서비스 안정성을 위해 과도한
                                        호출을 제한하고 있습니다
                                      </small>
                                    </dd>
                                    <br />
                                    <br />
                                    <span className="text-azure fs-7 fw-bold">
                                      ※ 믹스형API 사용시 주의사항
                                    </span>
                                    <br /> 심리스로 게임실행시 당사측에 입금된
                                    회원의 머니가 남아있는경우 실행이
                                    불가능합니다
                                    <br /> 심리스로 게임을 실행할경우{" "}
                                    <span className="text-danger fw-bold">
                                      반드시 출금API를 호출하여 회원의 머니를
                                      회수
                                    </span>
                                    후 진행해주세요
                                    <br />
                                    <br />
                                    EX) <br /> 심리스 실행시 : 출금API
                                    호출성공후 심리스 게임실행
                                    <br /> 트랜스퍼 실행시 : 입금API로 회원머니
                                    입금후 트랜스퍼 게임실행 <br />
                                    <br />
                                    <span className="text-azure fs-7 fw-bold">
                                      ※ 심리스 API 사용시 주의사항
                                    </span>
                                    <br /> 게임실행시 업체측에 유저존재 여부를
                                    확인하기위해 잔액조회콜백을 전송하게 됩니다
                                    <br /> 심리스 환경에서 게임실행에 성공하기
                                    위해서는 먼저 [심리스API → 1.잔액확인콜백]이
                                    정상작동해야합니다
                                    <br />
                                    <br />
                                    <span className="text-azure fs-7 fw-bold">
                                      ※ 게임실행 주의사항
                                    </span>
                                    <br /> 카지노 게임실행시 gameKey 항목에
                                    스킨을 입력해주세요 스킨은 API 부록에서
                                    확인가능합니다
                                    <br /> 카지노 외 게임실행시 gameKey 항목에
                                    gameKey를 입력해주세요
                                    <br />
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-xl-8 col-xxl-8">
                                  <div className="p-1" id="menu2">
                                    <div className="card text-bg-light">
                                      <div className="card-header">
                                        <h5>API Data</h5>
                                      </div>
                                      <div className="card-body">
                                        <h6 className="mt-1 card-subtitle mb-2 text-body-secondary">
                                          <span className="text-primary">
                                            Request Url
                                          </span>
                                        </h6>
                                        <input
                                          className="form-control"
                                          disabled
                                          type="text"
                                        />
                                        <hr />
                                        <h6 className="mt-1 card-subtitle mb-2 text-body-secondary">
                                          <span className="text-primary">
                                            Header Data
                                          </span>
                                        </h6>
                                        <div className="table-responsive">
                                          <table className="table table-primary mb-2">
                                            <colgroup>
                                              <col />
                                              <col />
                                              <col />
                                              <col />
                                              <col />
                                            </colgroup>
                                            <thead>
                                              <tr>
                                                <th className="text-center">
                                                  <b>Field</b>
                                                </th>
                                                <th className="text-center">
                                                  <b>Value</b>
                                                </th>
                                                <th className="text-center">
                                                  <b>Required</b>
                                                </th>
                                                <th className="text-center">
                                                  <b>Desc</b>
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr>
                                                <td>
                                                  <b>method</b>
                                                </td>
                                                <td>
                                                  <div className="form-group">
                                                    <input
                                                      className="form-control"
                                                      disabled
                                                      type="text"
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center">
                                                  <span className="badge bg-info">
                                                    YES
                                                  </span>
                                                </td>
                                                <td>POST</td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <b>accept</b>
                                                </td>
                                                <td>
                                                  <div className="form-group">
                                                    <input
                                                      className="form-control"
                                                      disabled
                                                      type="text"
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center">
                                                  <span className="badge bg-info">
                                                    YES
                                                  </span>
                                                </td>
                                                <td>Application type</td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <b>content-type</b>
                                                </td>
                                                <td>
                                                  <div className="form-group">
                                                    <input
                                                      className="form-control"
                                                      disabled
                                                      type="text"
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center">
                                                  <span className="badge bg-info">
                                                    YES
                                                  </span>
                                                </td>
                                                <td>Application</td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <b>hash</b>
                                                </td>
                                                <td>
                                                  <div className="form-group">
                                                    <input
                                                      className="form-control"
                                                      disabled
                                                      type="text"
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center">
                                                  <span className="badge bg-info">
                                                    YES
                                                  </span>
                                                </td>
                                                <td>hash</td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <b>agent</b>
                                                </td>
                                                <td>
                                                  <div className="form-group">
                                                    <input
                                                      className="form-control"
                                                      disabled
                                                      type="text"
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center">
                                                  <span className="badge bg-info">
                                                    YES
                                                  </span>
                                                </td>
                                                <td>에이전트 아이디</td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                        <h6 className="mt-1 card-subtitle mb-2 text-body-secondary">
                                          <span className="text-primary">
                                            Body Data
                                          </span>
                                        </h6>
                                        <div className="table-responsive">
                                          <table className="table mb-2">
                                            <colgroup>
                                              <col />
                                              <col />
                                              <col />
                                              <col />
                                              <col />
                                            </colgroup>
                                            <thead>
                                              <tr>
                                                <th className="text-center">
                                                  <b>Field</b>
                                                </th>
                                                <th className="text-center">
                                                  <b>Value</b>
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-bs-placement="top"
                                                  data-bs-toggle="tooltip"
                                                  title="문자열 처리 과정에서 byte 처리에 오류가 발생할 가능성을 고려하여, 글자 수를 기준으로 처리하고 있습니다">
                                                  <b>Length</b>
                                                  <em className="icon ni ni-info-fill vam" />
                                                </th>
                                                <th className="text-center">
                                                  <b>Type</b>
                                                </th>
                                                <th className="text-center">
                                                  <b>Required</b>
                                                </th>
                                                <th className="text-center">
                                                  <b>Desc</b>
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr>
                                                <td className="align-middle">
                                                  <b>vendorKey</b>
                                                </td>
                                                <td className="align-middle">
                                                  <div className="form-group">
                                                    <input
                                                      className="form-control"
                                                      disabled
                                                      name="vendorKey"
                                                      type="text"
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center align-middle">
                                                  <div className="form-wrap align-middle">
                                                    <select
                                                      className="form-select js-select2"
                                                      data-placeholder="에볼루션 카지노"
                                                      data-search="off"
                                                      id="selectVendor_play">
                                                      <option value="evolution_casino">
                                                        에볼루션 카지노
                                                      </option>
                                                      <option value="dreamgaming_casino">
                                                        드림게이밍
                                                      </option>
                                                      <option value="ag_casino">
                                                        아시안게이밍 카지노
                                                      </option>
                                                      <option value="pragmatic_casino">
                                                        프라그마틱 카지노
                                                      </option>
                                                      <option value="mggrand_casino">
                                                        마이크로게이밍 그랜드
                                                        카지노
                                                      </option>
                                                      <option value="mggrand_slot">
                                                        word.마이크로게이밍
                                                        그랜드 슬롯
                                                      </option>
                                                      <option value="orientalgame_casino">
                                                        오리엔탈 게이밍
                                                      </option>
                                                      <option value="bg_casino">
                                                        빅게이밍
                                                      </option>
                                                      <option value="motivation_casino">
                                                        모티베이션 카지노
                                                      </option>
                                                      <option value="ezugi_casino">
                                                        이주기
                                                      </option>
                                                      <option value="taishan_casino">
                                                        타이산 카지노
                                                      </option>
                                                      <option value="skywind_casino">
                                                        스카이윈드 카지노
                                                      </option>
                                                      <option value="betgames_casino">
                                                        벳게임즈 TV
                                                      </option>
                                                      <option value="sexy_casino">
                                                        섹시 바카라
                                                      </option>
                                                      <option value="dblive_casino">
                                                        DB Live 카지노
                                                      </option>
                                                      <option value="bota_casino">
                                                        보타 카지노
                                                      </option>
                                                      <option value="pragmatic_slot">
                                                        프라그마틱 슬롯
                                                      </option>
                                                      <option value="ag_slot">
                                                        아시안게이밍 슬롯
                                                      </option>
                                                      <option value="habanero_slot">
                                                        하바네로
                                                      </option>
                                                      <option value="blueprint_slot">
                                                        블루프린트 슬롯
                                                      </option>
                                                      <option value="cq9_slot">
                                                        CQ9 슬롯
                                                      </option>
                                                      <option value="evolution_redtiger">
                                                        레드타이거
                                                      </option>
                                                      <option value="spearhead_slot">
                                                        슬롯 매트릭스
                                                      </option>
                                                      <option value="gmw_slot">
                                                        GMW
                                                      </option>
                                                      <option value="booongo_slot">
                                                        부운고
                                                      </option>
                                                      <option value="netent_slot">
                                                        넷엔트
                                                      </option>
                                                      <option value="btg_slot">
                                                        BTG
                                                      </option>
                                                      <option value="pgsoft_slot">
                                                        PG소프트
                                                      </option>
                                                      <option value="aspect_slot">
                                                        아스펙트
                                                      </option>
                                                      <option value="betsoft_slot">
                                                        벳소프트 슬롯
                                                      </option>
                                                      <option value="skywind_slot">
                                                        스카이윈드 슬롯
                                                      </option>
                                                      <option value="ftg_slot">
                                                        FTG 슬롯
                                                      </option>
                                                      <option value="netgaming">
                                                        넷게이밍
                                                      </option>
                                                      <option value="ps_slot">
                                                        플레이스타 슬롯
                                                      </option>
                                                      <option value="naga_slot">
                                                        NAGA
                                                      </option>
                                                      <option value="nspin_slot">
                                                        넥스트스핀 슬롯
                                                      </option>
                                                      <option value="playngo_slot">
                                                        플레이앤고
                                                      </option>
                                                      <option value="evo_slot">
                                                        에보플레이 슬롯
                                                      </option>
                                                      <option value="aux_slot">
                                                        아바타UX 슬롯
                                                      </option>
                                                      <option value="relax_slot">
                                                        릴렉스
                                                      </option>
                                                      <option value="reelplay_slot">
                                                        릴플레이 슬롯
                                                      </option>
                                                      <option value="fantasma_slot">
                                                        판타즈마 슬롯
                                                      </option>
                                                      <option value="boomerang_slot">
                                                        부메랑 슬롯
                                                      </option>
                                                      <option value="4tp_slot">
                                                        포더플레이어 슬롯
                                                      </option>
                                                      <option value="nlc_slot">
                                                        노리밋시티 슬롯
                                                      </option>
                                                      <option value="hs_slot">
                                                        핵쏘우게이밍 슬롯
                                                      </option>
                                                      <option value="joker_slot">
                                                        조커 슬롯
                                                      </option>
                                                      <option value="jili_slot">
                                                        JILI 슬롯
                                                      </option>
                                                      <option value="funkygames_slot">
                                                        펀키게임즈 슬롯
                                                      </option>
                                                      <option value="bgaming_slot">
                                                        비게이밍 슬롯
                                                      </option>
                                                      <option value="booming_slot">
                                                        부밍게임즈 슬롯
                                                      </option>
                                                      <option value="expanse_slot">
                                                        익스팬스 슬롯
                                                      </option>
                                                      <option value="dragoonsoft_slot">
                                                        드래곤소프트
                                                      </option>
                                                      <option value="wazdan_slot">
                                                        와즈단
                                                      </option>
                                                      <option value="octoplay_slot">
                                                        옥토플레이
                                                      </option>
                                                      <option value="ygg_slot">
                                                        이그드라실
                                                      </option>
                                                      <option value="bt1_sports">
                                                        BT1
                                                      </option>
                                                    </select>
                                                  </div>
                                                </td>
                                                <td className="text-center align-middle">
                                                  String
                                                </td>
                                                <td className="text-center align-middle">
                                                  <span className="badge bg-info">
                                                    YES
                                                  </span>
                                                </td>
                                                <td>게임사 벤더키</td>
                                              </tr>
                                              <tr>
                                                <td className="align-middle">
                                                  <b>gameKey</b>
                                                </td>
                                                <td className="align-middle">
                                                  <div className="form-group">
                                                    <input
                                                      className="form-control"
                                                      name="gameKey"
                                                      type="text"
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center align-middle">
                                                  <div className="form-group">
                                                    <select
                                                      className="form-select"
                                                      id="games"
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center align-middle">
                                                  String
                                                </td>
                                                <td className="text-center align-middle">
                                                  <span className="badge bg-info">
                                                    YES
                                                  </span>
                                                </td>
                                                <td>
                                                  특정 게임을 식별하기 위한 고유
                                                  키입니다 (\`vendorKey\`를
                                                  선택한 후에 제공됩니다)
                                                </td>
                                              </tr>
                                              <tr>
                                                <td className="align-middle">
                                                  <b>siteUsername</b>
                                                </td>
                                                <td className="align-middle">
                                                  <div className="form-group">
                                                    <input
                                                      className="form-control"
                                                      name="siteUsername"
                                                      type="text"
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center align-middle">
                                                  <div className="form-group">
                                                    <span>3글자 ~ </span>
                                                    <span>22글자</span>
                                                  </div>
                                                </td>
                                                <td className="text-center align-middle">
                                                  String
                                                </td>
                                                <td className="text-center align-middle">
                                                  <span className="badge bg-info">
                                                    YES
                                                  </span>
                                                </td>
                                                <td>
                                                  사이트 회원아이디
                                                  (실사이트에서 사용하는 고유
                                                  회원 아이디)
                                                </td>
                                              </tr>
                                              <tr>
                                                <td className="align-middle">
                                                  <b>nickname</b>
                                                </td>
                                                <td className="align-middle">
                                                  <div className="form-group">
                                                    <input
                                                      className="form-control"
                                                      name="nickname"
                                                      type="text"
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center align-middle">
                                                  <div className="form-group">
                                                    <span>2글자 ~ </span>
                                                    <span>22글자</span>
                                                  </div>
                                                </td>
                                                <td className="text-center align-middle">
                                                  String
                                                </td>
                                                <td className="text-center align-middle">
                                                  <span className="badge bg-danger">
                                                    NO
                                                  </span>
                                                </td>
                                                <td>
                                                  사이트 닉네임 (게임 중에 다른
                                                  플레이어에게 보여지는
                                                  회원의닉네임입니다)
                                                </td>
                                              </tr>
                                              <tr>
                                                <td className="align-middle">
                                                  <b>ip</b>
                                                </td>
                                                <td className="align-middle">
                                                  <div className="form-group">
                                                    <input
                                                      className="form-control"
                                                      name="ip"
                                                      type="text"
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center align-middle">
                                                  <div className="form-group" />
                                                </td>
                                                <td className="text-center align-middle">
                                                  String
                                                </td>
                                                <td className="text-center align-middle">
                                                  <span className="badge bg-info">
                                                    YES
                                                  </span>
                                                </td>
                                                <td>회원접속아이피</td>
                                              </tr>
                                              <tr>
                                                <td className="align-middle">
                                                  <b>language</b>
                                                </td>
                                                <td className="align-middle">
                                                  <div className="form-group">
                                                    <input
                                                      className="form-control"
                                                      name="language"
                                                      type="text"
                                                    />{" "}
                                                  </div>
                                                </td>
                                                <td className="text-center align-middle">
                                                  <div className="form-group">
                                                    <select
                                                      className="form-select js-select2"
                                                      id="selectLanguage">
                                                      <option value="">
                                                        :: language ::
                                                      </option>
                                                      <option value="ko">
                                                        {" "}
                                                        ko{" "}
                                                      </option>
                                                      <option value="cn">
                                                        {" "}
                                                        cn{" "}
                                                      </option>
                                                      <option value="en">
                                                        {" "}
                                                        en{" "}
                                                      </option>
                                                      <option value="th">
                                                        {" "}
                                                        th{" "}
                                                      </option>
                                                      <option value="vn">
                                                        {" "}
                                                        vn{" "}
                                                      </option>
                                                      <option value="mn">
                                                        {" "}
                                                        mn{" "}
                                                      </option>
                                                    </select>
                                                  </div>
                                                </td>
                                                <td className="text-center align-middle">
                                                  String
                                                </td>
                                                <td className="text-center align-middle">
                                                  <span className="badge bg-danger">
                                                    NO
                                                  </span>
                                                </td>
                                                <td>
                                                  인게임 언어팩 (기본:영문)
                                                </td>
                                              </tr>
                                              <tr>
                                                <td className="align-middle">
                                                  <b>platform</b>
                                                </td>
                                                <td className="align-middle">
                                                  <div className="form-group">
                                                    <input
                                                      className="form-control"
                                                      name="platform"
                                                      type="text"
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center align-middle">
                                                  <div className="form-group" />
                                                </td>
                                                <td className="text-center align-middle">
                                                  String
                                                </td>
                                                <td className="text-center align-middle">
                                                  <span className="badge bg-danger">
                                                    NO
                                                  </span>
                                                </td>
                                                <td>
                                                  회원브라우저 환경 (desktop,
                                                  mobile)
                                                </td>
                                              </tr>
                                              <tr>
                                                <td className="align-middle">
                                                  <b>requestKey</b>
                                                </td>
                                                <td className="align-middle">
                                                  <div className="form-group">
                                                    <input
                                                      className="form-control"
                                                      name="requestKey"
                                                      type="text"
                                                    />
                                                  </div>
                                                </td>
                                                <td className="text-center align-middle">
                                                  <div className="form-group" />
                                                </td>
                                                <td className="text-center align-middle">
                                                  String
                                                </td>
                                                <td className="text-center align-middle">
                                                  <span className="badge bg-info">
                                                    YES
                                                  </span>
                                                </td>
                                                <td>중복호출방지 키</td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                        <div className="form-group text-center">
                                          <button
                                            className="btn btn-primary btn-lg"
                                            type="submit">
                                            <i className="fas fa-paper-plane" />
                                            Request{" "}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-xl-4 col-xxl-4">
                                  <div className="p-1" id="menu3">
                                    <div className="card text-bg-light">
                                      <div className="card-header">
                                        <h5>CODE</h5>
                                      </div>
                                      <div className="card-body">
                                        <ul
                                          className="nav nav-tabs nav-pills mb-3"
                                          id="animateLine"
                                          role="tablist">
                                          <li className="nav-item">
                                            <button
                                              className="nav-link active"
                                              data-bs-target="#tab-menu5-play"
                                              data-bs-toggle="tab"
                                              id="home-tab"
                                              type="button">
                                              {" "}
                                              Res Data{" "}
                                            </button>
                                          </li>
                                          <li className="nav-item">
                                            <button
                                              className="nav-link"
                                              data-bs-target="#tab-menu1-play"
                                              data-bs-toggle="tab"
                                              id="home-tab"
                                              type="button">
                                              {" "}
                                              NodeJs{" "}
                                            </button>
                                          </li>
                                          <li className="nav-item">
                                            <button
                                              className="nav-link"
                                              data-bs-target="#tab-menu2-play"
                                              data-bs-toggle="tab">
                                              {" "}
                                              PHP{" "}
                                            </button>
                                          </li>
                                          <li className="nav-item">
                                            <button
                                              className="nav-link"
                                              data-bs-target="#tab-menu3-play"
                                              data-bs-toggle="tab">
                                              {" "}
                                              Java{" "}
                                            </button>
                                          </li>
                                          <li className="nav-item">
                                            <button
                                              className="nav-link"
                                              data-bs-target="#tab-menu4-play"
                                              data-bs-toggle="tab">
                                              {" "}
                                              Asp{" "}
                                            </button>
                                          </li>
                                        </ul>
                                        <div
                                          className="tab-content"
                                          id="iconTabContent-1">
                                          <div
                                            className="tab-pane fade show active"
                                            id="tab-menu5-play">
                                            <pre className="rounded-lg">
                                              <code className="javascript hljs">
                                                {`{  `}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    "code"
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-number">
                                                  <span className="hljs-number">
                                                    0
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    // 0: 정상, -1: 오류 메시지
                                                    확인
                                                  </span>
                                                </span>
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    "url"
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    "https://url...."
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    // 게임 URL
                                                  </span>
                                                </span>
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    "userId"
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-number">
                                                  <span className="hljs-number">
                                                    0
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    // API 등록 회원코드
                                                  </span>
                                                </span>
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    "balance"
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-number">
                                                  <span className="hljs-number">
                                                    0
                                                  </span>
                                                </span>
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    // 회원 잔액정보
                                                  </span>
                                                </span>
                                                {`}																										`}
                                              </code>
                                            </pre>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="tab-menu1-play">
                                            <pre className="rounded-lg">
                                              <code className="javascript hljs">
                                                <span className="hljs-keyword">
                                                  <span className="hljs-keyword">
                                                    var
                                                  </span>
                                                </span>{" "}
                                                axios ={" "}
                                                <span className="hljs-built_in">
                                                  <span className="hljs-built_in">
                                                    require
                                                  </span>
                                                </span>
                                                (
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'axios'
                                                  </span>
                                                </span>
                                                );
                                                <span className="hljs-keyword">
                                                  <span className="hljs-keyword">
                                                    var
                                                  </span>
                                                </span>{" "}
                                                qs ={" "}
                                                <span className="hljs-built_in">
                                                  <span className="hljs-built_in">
                                                    require
                                                  </span>
                                                </span>
                                                (
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'qs'
                                                  </span>
                                                </span>
                                                );
                                                <span className="hljs-keyword">
                                                  <span className="hljs-keyword">
                                                    var
                                                  </span>
                                                </span>
                                                {` data = qs.stringify({  `}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'vendorKey'
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'evolution-n'
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'gameKey'
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    ''
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'language'
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'ko'
                                                  </span>
                                                </span>
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'siteUsername'
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'SiteID'
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'nickname'
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    ''
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'ip'
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    '127.0.0.1'
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'platform'
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'desktop'
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'requestKey'
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    '1745199170812'
                                                  </span>
                                                </span>
                                                {`});`}
                                                <span className="hljs-keyword">
                                                  <span className="hljs-keyword">
                                                    var
                                                  </span>
                                                </span>
                                                {` config = {  `}
                                                <span className="hljs-attr">
                                                  <span className="hljs-attr">
                                                    method
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'post'
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-attr">
                                                  <span className="hljs-attr">
                                                    url
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'API 요청 URL/play'
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-attr">
                                                  <span className="hljs-attr">
                                                    headers
                                                  </span>
                                                </span>
                                                {`: {	`}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'agent'
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'Matrixgames'
                                                  </span>
                                                </span>
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'secretKey'
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'ce3da8a33f5f6dae8620f3126ac6cd0b'
                                                  </span>
                                                </span>
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'User-agent'
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'Mozilla'
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'hash'
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'null'
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'Content-Type'
                                                  </span>
                                                </span>
                                                :{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'application/x-www-form-urlencoded'
                                                  </span>
                                                </span>
                                                {`  },  `}
                                                <span className="hljs-attr">
                                                  <span className="hljs-attr">
                                                    data
                                                  </span>
                                                </span>
                                                {` : data};axios(config).then(`}
                                                <span className="hljs-function">
                                                  <span className="hljs-keyword">
                                                    <span className="hljs-function">
                                                      <span className="hljs-keyword">
                                                        function
                                                      </span>
                                                    </span>
                                                  </span>
                                                  <span className="hljs-function">
                                                    {" "}
                                                    (
                                                  </span>
                                                  <span className="hljs-params">
                                                    <span className="hljs-function">
                                                      <span className="hljs-params">
                                                        response
                                                      </span>
                                                    </span>
                                                  </span>
                                                  <span className="hljs-function">
                                                    ){" "}
                                                  </span>
                                                </span>
                                                {`{  `}
                                                <span className="hljs-built_in">
                                                  <span className="hljs-built_in">
                                                    console
                                                  </span>
                                                </span>
                                                .log(
                                                <span className="hljs-built_in">
                                                  <span className="hljs-built_in">
                                                    JSON
                                                  </span>
                                                </span>
                                                {`.stringify(response.data));}).catch(`}
                                                <span className="hljs-function">
                                                  <span className="hljs-keyword">
                                                    <span className="hljs-function">
                                                      <span className="hljs-keyword">
                                                        function
                                                      </span>
                                                    </span>
                                                  </span>
                                                  <span className="hljs-function">
                                                    {" "}
                                                    (
                                                  </span>
                                                  <span className="hljs-params">
                                                    <span className="hljs-function">
                                                      <span className="hljs-params">
                                                        error
                                                      </span>
                                                    </span>
                                                  </span>
                                                  <span className="hljs-function">
                                                    ){" "}
                                                  </span>
                                                </span>
                                                {`{  `}
                                                <span className="hljs-built_in">
                                                  <span className="hljs-built_in">
                                                    console
                                                  </span>
                                                </span>
                                                {`.log(error);});																										`}
                                              </code>
                                            </pre>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="tab-menu2-play">
                                            <pre className="rounded-lg">
                                              <code className="php hljs">
                                                <span className="hljs-meta">
                                                  <span className="hljs-meta">
                                                    {`<?php`}
                                                  </span>
                                                </span>
                                                <span className="hljs-variable">
                                                  <span className="hljs-variable">
                                                    $curl
                                                  </span>
                                                </span>{" "}
                                                = curl_init();curl_setopt_array(
                                                <span className="hljs-variable">
                                                  <span className="hljs-variable">
                                                    $curl
                                                  </span>
                                                </span>
                                                ,{" "}
                                                <span className="hljs-keyword">
                                                  <span className="hljs-keyword">
                                                    array
                                                  </span>
                                                </span>
                                                {`(  CURLOPT_URL => `}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'API 요청 URL/play'
                                                  </span>
                                                </span>
                                                {`,  CURLOPT_RETURNTRANSFER => `}
                                                <span className="hljs-literal">
                                                  <span className="hljs-literal">
                                                    true
                                                  </span>
                                                </span>
                                                {`,  CURLOPT_ENCODING => `}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    ''
                                                  </span>
                                                </span>
                                                {`,  CURLOPT_MAXREDIRS => `}
                                                <span className="hljs-number">
                                                  <span className="hljs-number">
                                                    10
                                                  </span>
                                                </span>
                                                {`,  CURLOPT_TIMEOUT => `}
                                                <span className="hljs-number">
                                                  <span className="hljs-number">
                                                    0
                                                  </span>
                                                </span>
                                                {`,  CURLOPT_FOLLOWLOCATION => `}
                                                <span className="hljs-literal">
                                                  <span className="hljs-literal">
                                                    true
                                                  </span>
                                                </span>
                                                {`,  CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,  CURLOPT_CUSTOMREQUEST => `}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'POST'
                                                  </span>
                                                </span>
                                                {`,  CURLOPT_POSTFIELDS => `}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'vendorKey=evolution-n&gameKey=&siteUsername=SiteID&nickname=&ip=127.0.0.1&language=ko&platform=desktop&requestKey=1745199170812'
                                                  </span>
                                                </span>
                                                {`,  CURLOPT_HTTPHEADER => `}
                                                <span className="hljs-keyword">
                                                  <span className="hljs-keyword">
                                                    array
                                                  </span>
                                                </span>
                                                (
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'agent: Matrixgames'
                                                  </span>
                                                </span>
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'secretKey:
                                                    ce3da8a33f5f6dae8620f3126ac6cd0b'
                                                  </span>
                                                </span>
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'User-agent: Mozilla'
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'hash: null'
                                                  </span>
                                                </span>
                                                ,
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    'Content-Type:
                                                    application/x-www-form-urlencoded'
                                                  </span>
                                                </span>
                                                ),));
                                                <span className="hljs-variable">
                                                  <span className="hljs-variable">
                                                    $response
                                                  </span>
                                                </span>{" "}
                                                = curl_exec(
                                                <span className="hljs-variable">
                                                  <span className="hljs-variable">
                                                    $curl
                                                  </span>
                                                </span>
                                                );curl_close(
                                                <span className="hljs-variable">
                                                  <span className="hljs-variable">
                                                    $curl
                                                  </span>
                                                </span>
                                                );
                                                <span className="hljs-keyword">
                                                  <span className="hljs-keyword">
                                                    echo
                                                  </span>
                                                </span>{" "}
                                                <span className="hljs-variable">
                                                  <span className="hljs-variable">
                                                    $response
                                                  </span>
                                                </span>
                                                ;
                                              </code>
                                            </pre>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="tab-menu3-play">
                                            <pre className="rounded-lg">
                                              <code className="java hljs">
                                                OkHttpClient client ={" "}
                                                <span className="hljs-keyword">
                                                  <span className="hljs-keyword">
                                                    new
                                                  </span>
                                                </span>{" "}
                                                OkHttpClient().newBuilder().build();MediaType
                                                mediaType = MediaType.parse(
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    "application/x-www-form-urlencoded"
                                                  </span>
                                                </span>
                                                );RequestBody body =
                                                RequestBody.create(mediaType,{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    "vendorKey=evolution-n&gameKey=&siteUsername=SiteID&nickname=&ip=127.0.0.1&language=ko&platform=desktop&requestKey=1745199170812"
                                                  </span>
                                                </span>
                                                );Request request ={" "}
                                                <span className="hljs-keyword">
                                                  <span className="hljs-keyword">
                                                    new
                                                  </span>
                                                </span>{" "}
                                                Request.Builder() .url(
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    "API 요청 URL/play"
                                                  </span>
                                                </span>
                                                ) .method(
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    "POST"
                                                  </span>
                                                </span>
                                                , body) .addHeader(
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    "agent"
                                                  </span>
                                                </span>
                                                ,{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    "Matrixgames"
                                                  </span>
                                                </span>
                                                ) .addHeader(
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    "secretKey"
                                                  </span>
                                                </span>
                                                ,{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    "ce3da8a33f5f6dae8620f3126ac6cd0b"
                                                  </span>
                                                </span>
                                                ) .addHeader(
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    "User-agent"
                                                  </span>
                                                </span>
                                                ,{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    "Mozilla"
                                                  </span>
                                                </span>
                                                ) .addHeader(
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    "hash"
                                                  </span>
                                                </span>
                                                ,{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    "null"
                                                  </span>
                                                </span>
                                                ) .addHeader(
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    "Content-Type"
                                                  </span>
                                                </span>
                                                ,{" "}
                                                <span className="hljs-string">
                                                  <span className="hljs-string">
                                                    "application/x-www-form-urlencoded"
                                                  </span>
                                                </span>
                                                ) .build();Response response =
                                                client.newCall(request).execute();
                                              </code>
                                            </pre>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="tab-menu4-play">
                                            <pre className="rounded-lg">
                                              <code className="asp hljs gams">
                                                {`<%`}
                                                <span className="hljs-keyword">
                                                  <span className="hljs-keyword">
                                                    set
                                                  </span>
                                                </span>{" "}
                                                req{" "}
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    = Server.CreateObject(
                                                  </span>
                                                </span>
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    "MSXML2.ServerXMLHTTP"
                                                  </span>
                                                </span>
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    )
                                                  </span>
                                                </span>
                                                req.open{" "}
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    "POST"
                                                  </span>
                                                </span>
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    ,
                                                  </span>
                                                </span>{" "}
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    "API 요청 URL/play"
                                                  </span>
                                                </span>
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    , False
                                                  </span>
                                                </span>
                                                req.setRequestHeader{" "}
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    "accept"
                                                  </span>
                                                </span>
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    ,
                                                  </span>
                                                </span>{" "}
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    "application/json"
                                                  </span>
                                                </span>
                                                req.setRequestHeader{" "}
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    "Content-Type"
                                                  </span>
                                                </span>
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    ,
                                                  </span>
                                                </span>{" "}
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    "application/x-www-form-urlencoded"
                                                  </span>
                                                </span>
                                                req.setRequestHeader{" "}
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    "agent"
                                                  </span>
                                                </span>
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    ,
                                                  </span>
                                                </span>
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    "Matrixgames"
                                                  </span>
                                                </span>{" "}
                                                req.setRequestHeader{" "}
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    "secretKey"
                                                  </span>
                                                </span>
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    ,
                                                  </span>
                                                </span>{" "}
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    "ce3da8a33f5f6dae8620f3126ac6cd0b"
                                                  </span>
                                                </span>{" "}
                                                req.setRequestHeader{" "}
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    "hash"
                                                  </span>
                                                </span>
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    ,
                                                  </span>
                                                </span>{" "}
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    "null"
                                                  </span>
                                                </span>{" "}
                                                req.send{" "}
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    "vendorKey=evolution-n&gameKey=&siteUsername=SiteID&nickname=&ip=127.0.0.1&language=ko&platform=desktop&requestKey=1745199170812"
                                                  </span>
                                                </span>
                                                data{" "}
                                                <span className="hljs-comment">
                                                  <span className="hljs-comment">
                                                    = req.responseText
                                                  </span>
                                                </span>
                                                {`%>																										`}
                                              </code>
                                            </pre>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="p-1" id="menu4">
                                <div className="card text-bg-light">
                                  <div className="card-header">
                                    <h5>RESPONSE</h5>
                                  </div>
                                  <div className="card-body">
                                    <h6 className="mt-1 card-subtitle mb-2 text-body-secondary">
                                      <span className="text-primary">
                                        Response info
                                      </span>
                                    </h6>
                                    <div className="table-responsive">
                                      <table className="table mb-2">
                                        <colgroup>
                                          <col />
                                          <col />
                                          <col />
                                        </colgroup>
                                        <thead>
                                          <tr>
                                            <th className="text-center">
                                              Field
                                            </th>
                                            <th className="text-center">
                                              Type
                                            </th>
                                            <th className="text-center">
                                              Value{" "}
                                            </th>
                                            <th className="text-center">
                                              Desc
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <b>code</b>
                                            </td>
                                            <td>Number</td>
                                            <td>0, -1</td>
                                            <td>
                                              0: 정상, -1: 오류 메시지 확인
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <b>msg</b>
                                            </td>
                                            <td>String</td>
                                            <td>오류 메시지</td>
                                            <td>오류 메시지</td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <b>userId</b>
                                            </td>
                                            <td>Number</td>
                                            <td>000</td>
                                            <td>API 등록 회원코드</td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <b>url</b>
                                            </td>
                                            <td>String</td>
                                            <td>http://게임URL</td>
                                            <td>
                                              실행할 게임의 URL정보입니다.
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <b>balance</b>
                                            </td>
                                            <td>Number</td>
                                            <td>0</td>
                                            <td>회원 잔액정보</td>
                                          </tr>
                                        </tbody>
                                      </table>
                                      <h6 className="mt-1 card-subtitle mb-2 text-body-secondary">
                                        <span className="text-primary">
                                          Response Data
                                        </span>
                                      </h6>
                                      <div className="form-group">
                                        <pre className="rounded-lg">
                                          <code className="returnData json hljs" />
                                        </pre>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="form-group text-center">
                                <button
                                  className="btn btn-lg btn-success"
                                  disabled
                                  type="button">
                                  <i className="fas fa-gamepad" />
                                  실행
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card card-bordered m-3 mb-4">
            <div className="card-inner-group">
              <div className="card-inner p-3">
                <div className="card">
                  <div className="row p-0">
                    <div className="col h6 m-0 d-flex align-items-center text-azure">
                      공통 API를 완료한 경우 다음 과정으로 넘어가세요
                    </div>
                    <div className="col-auto text-end">
                      <table>
                        <tbody>
                          <tr>
                            <td>
                              <button className="btn btn-lg btn-azure btn-block">
                                <i className="fas fa-link" />  심리스 API
                              </button>
                            </td>
                            <td></td>
                            <td>
                              <button className="btn btn-lg btn-azure btn-block">
                                <i className="fas fa-link" />  트랜스퍼 API
                              </button>
                            </td>
                            <td>
                              <button className="btn btn-lg btn-azure btn-block">
                                <i className="fas fa-link" />  믹스형 API
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
	)
}